/* see /.rollup.config/vendor/elix.js */
const checkSize = Symbol("checkSize");
const componentDidMount = Symbol("componentDidMount");
const componentDidUpdate = Symbol("componentDidUpdate");
const contentSlot = Symbol("contentSlot");
const defaultTabIndex = Symbol("defaultTabIndex");
const defaultState = Symbol("defaultState");
const delegatesFocus = Symbol("delegatesFocus");
const effectEndTarget = Symbol("effectEndTarget");
const focusTarget = Symbol("focusTarget");
const getItemText = Symbol("getItemText");
const goDown = Symbol("goDown");
const goEnd = Symbol("goEnd");
const goLeft = Symbol("goLeft");
const goNext = Symbol("goNext");
const goPrevious = Symbol("goPrevious");
const goRight = Symbol("goRight");
const goStart = Symbol("goStart");
const goUp = Symbol("goUp");
const hasDynamicTemplate = Symbol("hasDynamicTemplate");
const ids = Symbol("ids");
const itemMatchesState = Symbol("itemMatchesState");
const itemsDelegate = Symbol("itemsDelegate");
const keydown = Symbol("keydown");
const mouseenter = Symbol("mouseenter");
const mouseleave = Symbol("mouseleave");
const nativeInternals = Symbol("nativeInternals");
const populate = Symbol("populate");
const raiseChangeEvents = Symbol("raiseChangeEvents");
const render = Symbol("render");
const renderChanges = Symbol("renderChanges");
const rendering = Symbol("rendering");
const scrollTarget = Symbol("scrollTarget");
const setState = Symbol("setState");
const startEffect = Symbol("startEffect");
const state = Symbol("state");
const swipeDown = Symbol("swipeDown");
const swipeDownComplete = Symbol("swipeDownComplete");
const swipeLeft = Symbol("swipeLeft");
const swipeLeftTransitionEnd = Symbol("swipeLeftTransitionEnd");
const swipeRight = Symbol("swipeRight");
const swipeRightTransitionEnd = Symbol("swipeRightTransitionEnd");
const swipeUp = Symbol("swipeUp");
const swipeUpComplete = Symbol("swipeUpComplete");
const swipeStart = Symbol("swipeStart");
const swipeTarget = Symbol("swipeTarget");
const tap = Symbol("tap");
const template = Symbol("template");
const update = Symbol("update");
const elixdebug = new URLSearchParams(location.search).get("elixdebug");
if (elixdebug === "true") {
   (window).elix = {
    internal: {
      checkSize,
      componentDidMount,
      componentDidUpdate,
      contentSlot,
      defaultState,
      defaultTabIndex,
      delegatesFocus,
      effectEndTarget,
      event,
      focusTarget,
      getItemText,
      goDown,
      goEnd,
      goLeft,
      goNext,
      goPrevious,
      goRight,
      goStart,
      goUp,
      hasDynamicTemplate,
      ids,
      itemMatchesState,
      itemsDelegate,
      keydown,
      mouseenter,
      mouseleave,
      nativeInternals,
      populate,
      raiseChangeEvents,
      render,
      renderChanges,
      rendering,
      scrollTarget,
      setState,
      startEffect,
      state,
      swipeDown,
      swipeDownComplete,
      swipeLeft,
      swipeLeftTransitionEnd,
      swipeRight,
      swipeRightTransitionEnd,
      swipeStart,
      swipeTarget,
      swipeUp,
      swipeUpComplete,
      tap,
      template,
      update
    }
  };
}

var internal = /*#__PURE__*/Object.freeze({
  __proto__: null,
  checkSize: checkSize,
  componentDidMount: componentDidMount,
  componentDidUpdate: componentDidUpdate,
  contentSlot: contentSlot,
  defaultTabIndex: defaultTabIndex,
  defaultState: defaultState,
  delegatesFocus: delegatesFocus,
  effectEndTarget: effectEndTarget,
  focusTarget: focusTarget,
  getItemText: getItemText,
  goDown: goDown,
  goEnd: goEnd,
  goLeft: goLeft,
  goNext: goNext,
  goPrevious: goPrevious,
  goRight: goRight,
  goStart: goStart,
  goUp: goUp,
  hasDynamicTemplate: hasDynamicTemplate,
  ids: ids,
  itemMatchesState: itemMatchesState,
  itemsDelegate: itemsDelegate,
  keydown: keydown,
  mouseenter: mouseenter,
  mouseleave: mouseleave,
  nativeInternals: nativeInternals,
  populate: populate,
  raiseChangeEvents: raiseChangeEvents,
  render: render,
  renderChanges: renderChanges,
  rendering: rendering,
  scrollTarget: scrollTarget,
  setState: setState,
  startEffect: startEffect,
  state: state,
  swipeDown: swipeDown,
  swipeDownComplete: swipeDownComplete,
  swipeLeft: swipeLeft,
  swipeLeftTransitionEnd: swipeLeftTransitionEnd,
  swipeRight: swipeRight,
  swipeRightTransitionEnd: swipeRightTransitionEnd,
  swipeUp: swipeUp,
  swipeUpComplete: swipeUpComplete,
  swipeStart: swipeStart,
  swipeTarget: swipeTarget,
  tap: tap,
  template: template,
  update: update
});

const mapBaseTagToCount = new Map();
function concat(...templates) {
  const result = document.createElement("template");
  const clones = templates.map(template =>
    document.importNode(template.content, true)
  );
  result.content.append(...clones);
  return result;
}
function createElement(descriptor) {
  if (typeof descriptor === "function") {
    let element;
    try {
      element = new descriptor();
    } catch (e) {
      if (e.name === "TypeError") {
        registerCustomElement(descriptor);
        element = new descriptor();
      } else {
        throw e;
      }
    }
    return element;
  } else if (descriptor instanceof HTMLTemplateElement) {
    const fragment = document.importNode(descriptor.content, true);
    return fragment.children.length === 1 ? fragment.children[0] : fragment;
  } else {
    return document.createElement(descriptor);
  }
}
function defaultSlot(tree) {
  return tree.querySelector("slot:not([name])");
}
function html(strings, ...substitutions) {
  const complete = strings
    .map((string, index) => {
      const substitution =
        index < substitutions.length ? substitutions[index] : "";
      return `${string}${substitution}`;
    })
    .join("");
  const template = document.createElement("template");
  template.innerHTML = complete;
  return template;
}
function registerCustomElement(classFn) {
  let baseTag;
  const classNameRegex = /^[A-Za-z][A-Za-z0-9_$]*$/;
  const classNameMatch = classFn.name && classFn.name.match(classNameRegex);
  if (classNameMatch) {
    const className = classNameMatch[0];
    const uppercaseRegEx = /([A-Z])/g;
    const hyphenated = className.replace(
      uppercaseRegEx,
      (match, letter, offset) => (offset > 0 ? `-${letter}` : letter)
    );
    baseTag = hyphenated.toLowerCase();
  } else {
    baseTag = "custom-element";
  }
  let count = mapBaseTagToCount.get(baseTag) || 0;
  let tag;
  for (; ; count++) {
    tag = `${baseTag}-${count}`;
    if (!customElements.get(tag)) {
      break;
    }
  }
  customElements.define(tag, classFn);
  mapBaseTagToCount.set(baseTag, count + 1);
}
function replace(original, replacement) {
  if (!original) {
    throw "The original element could not be found.";
  }
  const parent = original.parentNode;
  if (!parent) {
    throw "An element must have a parent before it can be substituted.";
  }
  if (
    (original instanceof HTMLElement || original instanceof SVGElement) &&
    (replacement instanceof HTMLElement || replacement instanceof SVGElement)
  ) {
    Array.prototype.forEach.call(original.attributes, (
       attribute
    ) => {
      if (
        !replacement.getAttribute(attribute.name) &&
        attribute.name !== "class" &&
        attribute.name !== "style"
      ) {
        replacement.setAttribute(attribute.name, attribute.value);
      }
    });
    Array.prototype.forEach.call(original.classList, (
       className
    ) => {
      replacement.classList.add(className);
    });
    Array.prototype.forEach.call(original.style, (
       key
    ) => {
      if (!replacement.style[key]) {
        replacement.style[key] = original.style[key];
      }
    });
  }
  replacement.append(...original.childNodes);
  parent.replaceChild(replacement, original);
  return replacement;
}
function transmute(original, descriptor) {
  if (original instanceof Array) {
    const replacements = original.map(node => transmute(node, descriptor));
    return replacements;
  } else if (original instanceof NodeList) {
    const replacements = [...original].map(node => transmute(node, descriptor));
    return replacements;
  } else if (
    (typeof descriptor === "function" && original.constructor === descriptor) ||
    (typeof descriptor === "string" &&
      original instanceof Element &&
      original.localName === descriptor)
  ) {
    return original;
  } else {
    const replacement = createElement(descriptor);
    replace(original, replacement);
    return replacement;
  }
}
function wrap(original, wrapper, destination) {
  const destinationNode = wrapper.querySelector(destination);
  if (!destinationNode) {
    throw `Can't find the wrapper destination indicated by "${destination}".`;
  }
  if (original.parentNode) {
    original.parentNode.replaceChild(wrapper, original);
    destinationNode.appendChild(original);
  } else if (original instanceof DocumentFragment) {
    destinationNode.append(...original.childNodes);
    original.appendChild(wrapper);
  }
}

var template$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  concat: concat,
  createElement: createElement,
  defaultSlot: defaultSlot,
  html: html,
  replace: replace,
  transmute: transmute,
  wrap: wrap
});

const generatedIdKey = Symbol("generatedId");
const mousedownListenerKey = Symbol("mousedownListener");
let generatedIdCount = 0;
function applyChildNodes(element, childNodes) {
  const copy = [...childNodes];
  const oldLength = element.childNodes.length;
  const newLength = copy.length;
  const length = Math.max(oldLength, newLength);
  for (let i = 0; i < length; i++) {
    const oldChild = element.childNodes[i];
    const newChild = copy[i];
    if (i >= oldLength) {
      element.appendChild(newChild);
    } else if (i >= newLength) {
      element.removeChild(element.childNodes[newLength]);
    } else if (oldChild !== newChild) {
      if (copy.indexOf(oldChild, i) >= i) {
        element.insertBefore(newChild, oldChild);
      } else {
        element.replaceChild(newChild, oldChild);
      }
    }
  }
}
function closestFocusableNode(node) {
  for (const current of selfAndComposedAncestors(node)) {
    const focusTarget$1 = current[focusTarget] || current;
    const focusable =
      focusTarget$1 instanceof HTMLElement &&
      focusTarget$1.tabIndex >= 0 &&
      !( (focusTarget$1).disabled) &&
      !(focusTarget$1 instanceof HTMLSlotElement);
    if (focusable) {
      return focusTarget$1;
    }
  }
  return null;
}
function* composedAncestors(node) {
  let current = node;
  while (true) {
    current =
      current instanceof HTMLElement && current.assignedSlot
        ? current.assignedSlot
        : current instanceof ShadowRoot
        ? current.host
        : current.parentNode;
    if (current) {
      yield current;
    } else {
      break;
    }
  }
}
function deepContains(container, target) {
  let current = target;
  while (current) {
    const parent = current.assignedSlot || current.parentNode || current.host;
    if (parent === container) {
      return true;
    }
    current = parent;
  }
  return false;
}
function ensureId(element) {
  let id = element.id || element[generatedIdKey];
  if (!id) {
    id = `_id${generatedIdCount++}`;
    element[generatedIdKey] = id;
  }
  return id;
}
function firstFocusableElement(root) {
  const focusableQuery =
    'a[href],area[href],button:not([disabled]),details,iframe,input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[contentEditable="true"],[tabindex]';
  const walker = walkComposedTree(
    root,
    ( node) =>
      node instanceof HTMLElement &&
      node.matches(focusableQuery) &&
      node.tabIndex >= 0
  );
  const { value } = walker.next();
  return value instanceof HTMLElement ? value : null;
}
function forwardFocus(origin, target) {
  if (origin[mousedownListenerKey]) {
    origin.removeEventListener("mousedown", origin[mousedownListenerKey]);
  }
  if (target) {
    origin[mousedownListenerKey] = ( event) => {
      if (event.button !== 0) {
        return;
      }
      const desiredTarget = target[focusTarget] || target;
      const focusableTarget = closestFocusableNode(desiredTarget);
      if (focusableTarget) {
        focusableTarget.focus();
        event.preventDefault();
      }
    };
    origin.addEventListener("mousedown", origin[mousedownListenerKey]);
  }
}
function indexOfItemContainingTarget(items, target) {
  return Array.prototype.findIndex.call(
    items,
    ( item) => item === target || deepContains(item, target)
  );
}
function ownEvent(node, event) {
  const cast = event;
  const eventSource = cast.composedPath()[0];
  return node === eventSource || deepContains(node, eventSource);
}
function* selfAndComposedAncestors(node) {
  if (node) {
    yield node;
    yield* composedAncestors(node);
  }
}
function* walkComposedTree(node, filter) {
  if (filter(node)) {
    yield node;
  }
  let children;
  if (node instanceof HTMLElement && node.shadowRoot) {
    children = node.shadowRoot.children;
  } else {
    const assignedNodes =
      node instanceof HTMLSlotElement
        ? node.assignedNodes({ flatten: true })
        : [];
    children =
      assignedNodes.length > 0
        ?
          assignedNodes
        :
          node.childNodes;
  }
  if (children) {
    for (let i = 0; i < children.length; i++) {
      yield* walkComposedTree(children[i], filter);
    }
  }
}

var utilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  applyChildNodes: applyChildNodes,
  closestFocusableNode: closestFocusableNode,
  composedAncestors: composedAncestors,
  deepContains: deepContains,
  ensureId: ensureId,
  firstFocusableElement: firstFocusableElement,
  forwardFocus: forwardFocus,
  indexOfItemContainingTarget: indexOfItemContainingTarget,
  ownEvent: ownEvent,
  selfAndComposedAncestors: selfAndComposedAncestors
});

const changeCallbacksKey = Symbol("changeCallbacks");
class State {
  constructor( defaults) {
    if (defaults) {
      applyStateChanges(this, defaults);
    }
  }
  copyWithChanges(changes) {
    const state = Object.assign(new State(), this);
    if (changes[changeCallbacksKey]) {
      state[changeCallbacksKey] = changes[changeCallbacksKey];
    }
    const changed = applyStateChanges(state, changes);
    return { state, changed };
  }
  onChange(dependencies, callback) {
    if (!this[changeCallbacksKey]) {
      this[changeCallbacksKey] = {};
    }
    const array = dependencies instanceof Array ? dependencies : [dependencies];
    array.forEach(dependency => {
      const changeCallbacks = this[changeCallbacksKey];
      if (!changeCallbacks[dependency]) {
        changeCallbacks[dependency] = [];
      }
      changeCallbacks[dependency].push(callback);
    });
  }
}
function equal(value1, value2) {
  if (value1 instanceof Date && value2 instanceof Date) {
    return value1.getTime() === value2.getTime();
  }
  return value1 === value2;
}
function fieldsChanged(state, changes) {
  let changed = null;
  for (const field in changes) {
    if (!equal(changes[field], state[field])) {
      if (!changed) {
        changed = {};
      }
      changed[field] = true;
    }
  }
  return changed;
}
function applyStateChanges(state, changes) {
  let result = null;
   let changed;
  for (; (changed = fieldsChanged(state, changes)); ) {
    Object.assign(state, changes);
    if (!result) {
      result = {};
    }
    Object.assign(result, changed);
    const changeCallbacks =  (state)[changeCallbacksKey];
    if (changeCallbacks) {
      const callbacksToRun = [];
      for (const field in changed) {
        const callbacksForField = changeCallbacks[field] || [];
        callbacksForField.forEach(callback => {
          if (!callbacksToRun.includes(callback)) {
            callbacksToRun.push(callback);
          }
        });
      }
      const results = callbacksToRun.map(callback => callback(state, changed));
      changes = Object.assign({}, ...results);
    }
  }
  return result;
}

const mountedKey = Symbol("mounted");
const stateKey = Symbol("state");
const raiseChangeEventsInNextRenderKey = Symbol(
  "raiseChangeEventsInNextRender"
);
const changedSinceLastRender = new WeakMap();
function ReactiveMixin(Base) {
  class Reactive extends Base {
    constructor() {
      super();
      this[setState](this[defaultState]);
    }
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
    }
    connectedCallback() {
      if (super.connectedCallback) {
        super.connectedCallback();
      }
      this[renderChanges]();
    }
    get [defaultState]() {
      return new State();
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
    }
    [renderChanges]() {
      const changed = changedSinceLastRender.get(this);
      if (!this[mountedKey] || changed !== null) {
        const saveRaiseChangeEvents = this[raiseChangeEvents];
        this[raiseChangeEvents] = this[
          raiseChangeEventsInNextRenderKey
        ];
        this[rendering] = true;
        this[render](changed);
        this[rendering] = false;
        changedSinceLastRender.set(this, null);
        if (!this[mountedKey]) {
          this[componentDidMount]();
          this[mountedKey] = true;
        } else {
          this[componentDidUpdate](changed);
        }
        this[raiseChangeEvents] = saveRaiseChangeEvents;
        this[raiseChangeEventsInNextRenderKey] = saveRaiseChangeEvents;
      }
    }
    async [setState](changes) {
      if (this[rendering]) {
        console.warn(
          `${this.constructor.name} called[internal.setState] during rendering, which you should avoid.\nSee https://elix.org/documentation/ReactiveMixin.`
        );
      }
      const firstSetState = this[stateKey] === undefined;
      if (firstSetState) {
        this[stateKey] = Object.freeze(new State());
      }
      const { state, changed } = this[stateKey].copyWithChanges(changes);
      const renderWorthy = firstSetState || changed;
      if (!renderWorthy) {
        return;
      }
      Object.freeze(state);
      this[stateKey] = state;
      const log = changedSinceLastRender.get(this) || {};
      Object.assign(log, changed);
      changedSinceLastRender.set(this, log);
      if (!(this.isConnected && renderWorthy)) {
        return;
      }
      if (this[raiseChangeEvents]) {
        this[raiseChangeEventsInNextRenderKey] = true;
      }
      await Promise.resolve();
      this[renderChanges]();
    }
    get [state]() {
      return this[stateKey];
    }
  }
  const elixdebug = new URLSearchParams(location.search).get("elixdebug");
  if (elixdebug === "true") {
    Object.defineProperty(Reactive.prototype, "state", {
      get() {
        return this[state];
      }
    });
  }
  return Reactive;
}

const classTemplateMap = new Map();
const shadowReferencesKey = Symbol("shadowReferences");
function ShadowTemplateMixin(Base) {
  class ShadowTemplate extends Base {
    get [ids]() {
      if (!this[shadowReferencesKey]) {
        const element = this;
        this[shadowReferencesKey] = new Proxy(
          {},
          {
            get(target, property, receiver) {
              return element.shadowRoot && typeof property === "string"
                ? element.shadowRoot.getElementById(property)
                : null;
            }
          }
        );
      }
      return this[shadowReferencesKey];
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (this.shadowRoot) {
        return;
      }
      const template = getTemplate(this);
      if (template) {
        const delegatesFocus$1 = this[delegatesFocus];
        const root = this.attachShadow({
          delegatesFocus: delegatesFocus$1,
          mode: "open"
        });
        const clone = document.importNode(template.content, true);
        root.appendChild(clone);
      }
    }
  }
  return ShadowTemplate;
}
function getTemplate(element) {
  const hasDynamicTemplate$1 = element[hasDynamicTemplate];
  let template$1 = hasDynamicTemplate$1
    ? undefined
    : classTemplateMap.get(element.constructor);
  if (template$1 === undefined) {
    template$1 = element[template] || null;
    if (template$1 && !(template$1 instanceof HTMLTemplateElement)) {
      throw `Warning: the [internal.template] property for ${element.constructor.name} must return an HTMLTemplateElement.`;
    }
    if (!hasDynamicTemplate$1) {
      classTemplateMap.set(element.constructor, template$1);
    }
  }
  return template$1;
}

const ReactiveElement = AttributeMarshallingMixin(
  ReactiveMixin(ShadowTemplateMixin(HTMLElement))
);

const booleanAttributes = {
  checked: true,
  defer: true,
  disabled: true,
  hidden: true,
  ismap: true,
  multiple: true,
  noresize: true,
  readonly: true,
  selected: true
};
const attributeToPropertyNames = {
  tabindex: "tabIndex"
};
const propertyNamesToAttributes = {
  tabIndex: "tabindex"
};
function AttributeMarshallingMixin(Base) {
  class AttributeMarshalling extends Base {
    attributeChangedCallback(attributeName, oldValue, newValue) {
      if (super.attributeChangedCallback) {
        super.attributeChangedCallback(attributeName, oldValue, newValue);
      }
      if (newValue !== oldValue && !this[rendering]) {
        const propertyName = attributeToPropertyName(attributeName);
        if (propertyName in this) {
          this[propertyName] = castPotentialBooleanAttribute(
            attributeName,
            newValue
          );
        }
      }
    }
    static get observedAttributes() {
      const elementClass = this;
      return attributesForClass(elementClass);
    }
  }
  return AttributeMarshalling;
}
function attributesForClass(classFn) {
  if (classFn === HTMLElement) {
    return [];
  }
  const baseClass = Object.getPrototypeOf(classFn.prototype).constructor;
  let baseAttributes = baseClass.observedAttributes;
  if (!baseAttributes) {
    baseAttributes = attributesForClass(baseClass);
  }
  const propertyNames = Object.getOwnPropertyNames(classFn.prototype);
  const setterNames = propertyNames.filter(propertyName => {
    const descriptor = Object.getOwnPropertyDescriptor(
      classFn.prototype,
      propertyName
    );
    return descriptor && typeof descriptor.set === "function";
  });
  const attributes = setterNames.map(setterName =>
    propertyNameToAttribute(setterName)
  );
  const diff = attributes.filter(
    attribute => baseAttributes.indexOf(attribute) < 0
  );
  const result = baseAttributes.concat(diff);
  const styleIndex = result.indexOf("style");
  if (styleIndex >= 0) {
    result.splice(styleIndex, 1);
  }
  return result;
}
function attributeToPropertyName(attributeName) {
  let propertyName = attributeToPropertyNames[attributeName];
  if (!propertyName) {
    const hyphenRegEx = /-([a-z])/g;
    propertyName = attributeName.replace(hyphenRegEx, match =>
      match[1].toUpperCase()
    );
    attributeToPropertyNames[attributeName] = propertyName;
  }
  return propertyName;
}
function castPotentialBooleanAttribute(attributeName, value) {
  if (booleanAttributes[attributeName]) {
    if (typeof value === "string") {
      return true;
    } else if (value === null) {
      return false;
    }
  }
  return value;
}
function propertyNameToAttribute(propertyName) {
  let attribute = propertyNamesToAttributes[propertyName];
  if (!attribute) {
    const uppercaseRegEx = /([A-Z])/g;
    attribute = propertyName.replace(uppercaseRegEx, "-$1").toLowerCase();
    propertyNamesToAttributes[propertyName] = attribute;
  }
  return attribute;
}

function FormElementMixin(Base) {
  class FormElement extends Base {
    constructor() {
      super();
      if (!this[nativeInternals] && this.attachInternals) {
        this[nativeInternals] = this.attachInternals();
      }
    }
    checkValidity() {
      return this[nativeInternals].checkValidity();
    }
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      updateValue(this);
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.value) {
        updateValue(this);
      }
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        validationMessage: "",
        valid: true
      });
    }
    get internals() {
      return this[nativeInternals];
    }
    static get formAssociated() {
      return true;
    }
    get form() {
      return this[nativeInternals].form;
    }
    get name() {
      return this[state].name;
    }
    set name(name) {
      if ("name" in Base.prototype) {
        super.name = name;
      }
      this[setState]({ name });
    }
    [render](changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.name) {
        this.setAttribute("name", this[state].name);
      }
      if (this[nativeInternals]) {
        if (changed.valid || changed.validationMessage) {
          const { valid, validationMessage } = this[state];
          if (valid) {
            this[nativeInternals].setValidity({});
          } else {
            this[nativeInternals].setValidity(
              {
                customError: true
              },
              validationMessage
            );
          }
        }
      }
    }
    reportValidity() {
      return this[nativeInternals].reportValidity();
    }
    get type() {
      return this.localName;
    }
    get validationMessage() {
      return this[state].validationMessage;
    }
    get validity() {
      return this[nativeInternals].validity;
    }
    get willValidate() {
      return this[nativeInternals].willValidate;
    }
  }
  return FormElement;
}
function updateValue(element) {
  if (element[nativeInternals]) {
    element[nativeInternals].setFormValue(
      element[state].value,
      element[state]
    );
  }
}

function SlotContentMixin(Base) {
  class SlotContent extends Base {
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      const slot = this[contentSlot];
      if (slot) {
        slot.addEventListener("slotchange", async () => {
          this[raiseChangeEvents] = true;
          const content = slot.assignedNodes({ flatten: true });
          Object.freeze(content);
          this[setState]({ content });
          await Promise.resolve();
          this[raiseChangeEvents] = false;
        });
      }
    }
    get [contentSlot]() {
       const slot =
        this.shadowRoot && this.shadowRoot.querySelector("slot:not([name])");
      if (!this.shadowRoot || !slot) {
        console.warn(
          `SlotContentMixin expects ${this.constructor.name} to define a shadow tree that includes a default (unnamed) slot.\nSee https://elix.org/documentation/SlotContentMixin.`
        );
      }
      return slot;
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        content: null
      });
    }
  }
  return SlotContent;
}

function DelegateFocusMixin(Base) {
  class DelegateFocus extends Base {
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
       const cast = this.shadowRoot;
      if (cast.delegatesFocus) {
        this.style.outline = "none";
      }
    }
    get [delegatesFocus]() {
      return true;
    }
    focus(focusOptions) {
       const cast = this.shadowRoot;
      if (cast.delegatesFocus) {
        super.focus(focusOptions);
        return;
      }
      const focusElement = this[focusTarget];
      if (focusElement) {
        focusElement.focus(focusOptions);
      }
    }
    get [focusTarget]() {
      return firstFocusableElement(this.shadowRoot);
    }
  }
  return DelegateFocus;
}

const extendsKey = Symbol("extends");
const focusableByDefault = {
  a: true,
  area: true,
  button: true,
  details: true,
  iframe: true,
  input: true,
  select: true,
  textarea: true
};
const reraiseEvents = {
  address: ["scroll"],
  blockquote: ["scroll"],
  caption: ["scroll"],
  center: ["scroll"],
  dd: ["scroll"],
  dir: ["scroll"],
  div: ["scroll"],
  dl: ["scroll"],
  dt: ["scroll"],
  fieldset: ["scroll"],
  form: ["reset", "scroll"],
  frame: ["load"],
  h1: ["scroll"],
  h2: ["scroll"],
  h3: ["scroll"],
  h4: ["scroll"],
  h5: ["scroll"],
  h6: ["scroll"],
  iframe: ["load"],
  img: ["abort", "error", "load"],
  input: ["abort", "change", "error", "select", "load"],
  li: ["scroll"],
  link: ["load"],
  menu: ["scroll"],
  object: ["error", "scroll"],
  ol: ["scroll"],
  p: ["scroll"],
  script: ["error", "load"],
  select: ["change", "scroll"],
  tbody: ["scroll"],
  tfoot: ["scroll"],
  thead: ["scroll"],
  textarea: ["change", "select", "scroll"]
};
const mouseEventNames = [
  "click",
  "dblclick",
  "mousedown",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "wheel"
];
const eventBubbles = {
  abort: true,
  change: true,
  reset: true
};
const blockElements = [
  "address",
  "article",
  "aside",
  "blockquote",
  "canvas",
  "dd",
  "div",
  "dl",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "li",
  "main",
  "nav",
  "noscript",
  "ol",
  "output",
  "p",
  "pre",
  "section",
  "table",
  "tfoot",
  "ul",
  "video"
];
const attributesWithoutProperties = [
  "accept-charset",
  "autoplay",
  "buffered",
  "challenge",
  "codebase",
  "colspan",
  "contenteditable",
  "controls",
  "crossorigin",
  "datetime",
  "dirname",
  "for",
  "formaction",
  "http-equiv",
  "icon",
  "ismap",
  "itemprop",
  "keytype",
  "language",
  "loop",
  "manifest",
  "maxlength",
  "minlength",
  "muted",
  "novalidate",
  "preload",
  "radiogroup",
  "readonly",
  "referrerpolicy",
  "rowspan",
  "scoped",
  "usemap"
];
const Base = DelegateFocusMixin(ReactiveElement);
class WrappedStandardElement extends Base {
  constructor() {
    super();
    if (!this[nativeInternals] && this.attachInternals) {
      this[nativeInternals] = this.attachInternals();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    const forwardAttribute = attributesWithoutProperties.indexOf(name) >= 0;
    if (forwardAttribute) {
      const innerAttributes = Object.assign(
        {},
        this[state].innerAttributes,
        {
          [name]: newValue
        }
      );
      this[setState]({ innerAttributes });
    } else {
      super.attributeChangedCallback(name, oldValue, newValue);
    }
  }
  blur() {
    this.inner.blur();
  }
  [componentDidMount]() {
    super[componentDidMount]();
    const eventNames = reraiseEvents[this.extends] || [];
    eventNames.forEach(eventName => {
      this.inner.addEventListener(eventName, () => {
        const event = new Event(eventName, {
          bubbles: eventBubbles[eventName] || false
        });
        this.dispatchEvent(event);
      });
    });
    if ("disabled" in this[ids].inner) {
      mouseEventNames.forEach(eventName => {
        this.addEventListener(eventName, event => {
          const element = this[ids].inner;
          if (element.disabled) {
            event.stopImmediatePropagation();
          }
        });
      });
    }
  }
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      innerAttributes: {},
      innerProperties: {}
    });
  }
  get [defaultTabIndex]() {
    return focusableByDefault[this.extends] ? 0 : -1;
  }
  get extends() {
    return this.constructor[extendsKey];
  }
  get inner() {
    const result = this[ids] && this[ids].inner;
    if (!result) {
      console.warn(
        "Attempted to get an inner standard element before it was instantiated."
      );
    }
    return result;
  }
  getInnerProperty(name) {
    const value = this[state].innerProperties[name];
    return value || (this.shadowRoot && this.inner[name]);
  }
  static get observedAttributes() {
    return [...super.observedAttributes, ...attributesWithoutProperties];
  }
  [render]( changed) {
    super[render](changed);
    const inner = this.inner;
    if (changed.tabIndex) {
      inner.tabIndex = this[state].tabIndex;
    }
    if (changed.innerAttributes) {
      const { innerAttributes } = this[state];
      for (const name in innerAttributes) {
        applyAttribute(inner, name, innerAttributes[name]);
      }
    }
    if (changed.innerProperties) {
      const { innerProperties } = this[state];
      Object.assign(inner, innerProperties);
      const { disabled } = innerProperties;
      if (disabled !== undefined) {
        this.toggleAttribute("disabled", disabled);
        if (
          this[nativeInternals] &&
          this[nativeInternals].states
        ) {
          this[nativeInternals].states.toggle("disabled", disabled);
        }
      }
    }
  }
  setInnerProperty(name, value) {
    const current = this[state].innerProperties[name];
    if (current !== value) {
      const innerProperties = Object.assign(
        {},
        this[state].innerProperties,
        {
          [name]: value
        }
      );
      this[setState]({ innerProperties });
    }
  }
  get [template]() {
    const display = blockElements.includes(this.extends)
      ? "block"
      : "inline-block";
    return html`
      <style>
        :host {
          display: ${display}
        }
        
        #inner {
          box-sizing: border-box;
          height: 100%;
          width: 100%;
        }
      </style>
      <${this.extends} id="inner" part="inner">
        <slot></slot>
      </${this.extends}>
    `;
  }
  static wrap(extendsTag) {
    class Wrapped extends WrappedStandardElement {}
     (Wrapped)[extendsKey] = extendsTag;
    const element = document.createElement(extendsTag);
    defineDelegates(Wrapped, Object.getPrototypeOf(element));
    return Wrapped;
  }
}
function applyAttribute(element, name, value) {
  if (booleanAttributes[name]) {
    if (typeof value === "string") {
      element.setAttribute(name, "");
    } else if (value === null) {
      element.removeAttribute(name);
    }
  } else {
    if (value != null) {
      element.setAttribute(name, value.toString());
    } else {
      element.removeAttribute(name);
    }
  }
}
function createDelegate(name, descriptor) {
  if (typeof descriptor.value === "function") {
    if (name !== "constructor") {
      return createMethodDelegate(name, descriptor);
    }
  } else if (
    typeof descriptor.get === "function" ||
    typeof descriptor.set === "function"
  ) {
    return createPropertyDelegate(name, descriptor);
  }
  return null;
}
function createMethodDelegate(name, descriptor) {
  const value = function( ...args) {
    this.inner[name](...args);
  };
  const delegate = {
    configurable: descriptor.configurable,
    enumerable: descriptor.enumerable,
    value,
    writable: descriptor.writable
  };
  return delegate;
}
function createPropertyDelegate(name, descriptor) {
  const delegate = {
    configurable: descriptor.configurable,
    enumerable: descriptor.enumerable
  };
  if (descriptor.get) {
    delegate.get = function() {
      return this.getInnerProperty(name);
    };
  }
  if (descriptor.set) {
    delegate.set = function( value) {
      this.setInnerProperty(name, value);
    };
  }
  if (descriptor.writable) {
    delegate.writable = descriptor.writable;
  }
  return delegate;
}
function defineDelegates(cls, prototype) {
  const names = Object.getOwnPropertyNames(prototype);
  names.forEach(name => {
    const descriptor = Object.getOwnPropertyDescriptor(prototype, name);
    if (!descriptor) {
      return;
    }
    const delegate = createDelegate(name, descriptor);
    if (delegate) {
      Object.defineProperty(cls.prototype, name, delegate);
    }
  });
}

const Base$1 = FormElementMixin(
  SlotContentMixin(WrappedStandardElement.wrap("textarea"))
);
class AutoSizeTextarea extends Base$1 {
  [componentDidMount]() {
    super[componentDidMount]();
    this[ids].inner.addEventListener("input", () => {
      this[raiseChangeEvents] = true;
      this[setState]({ valueTracksContent: false });
      const inner = this[ids].inner;
      this[setState]({
        value: inner.value
      });
      this[raiseChangeEvents] = false;
    });
    const textareaStyle = getComputedStyle(this[ids].inner);
    const lineHeight = this[ids].extraSpace.clientHeight;
    this[setState]({
      copyStyle: {
        "border-bottom-style": textareaStyle.borderBottomStyle,
        "border-bottom-width": textareaStyle.borderBottomWidth,
        "border-left-style": textareaStyle.borderLeftStyle,
        "border-left-width": textareaStyle.borderLeftWidth,
        "border-right-style": textareaStyle.borderRightStyle,
        "border-right-width": textareaStyle.borderRightWidth,
        "border-top-style": textareaStyle.borderTopStyle,
        "border-top-width": textareaStyle.borderTopWidth,
        "padding-bottom": textareaStyle.paddingBottom,
        "padding-left": textareaStyle.paddingLeft,
        "padding-right": textareaStyle.paddingRight,
        "padding-top": textareaStyle.paddingTop
      },
      lineHeight
    });
  }
  get [defaultState]() {
    const state = Object.assign(super[defaultState], {
      minimumRows: 1,
      value: null,
      valueTracksContent: true
    });
    state.onChange(["content", "valueTracksContent"], (state, changed) => {
      if (
        (changed.content || changed.valueTracksContent) &&
        state.valueTracksContent
      ) {
         const content = state.content;
        const value = getTextFromContent(content);
        return {
          value
        };
      }
      return null;
    });
    return state;
  }
  get minimumRows() {
    return this[state].minimumRows;
  }
  set minimumRows(minimumRows) {
    const parsed = Number(minimumRows);
    if (!isNaN(parsed)) {
      this[setState]({
        minimumRows: parsed
      });
    }
  }
  [render]( changed) {
    super[render](changed);
    const { copyStyle, lineHeight, minimumRows, value } = this[state];
    if (changed.copyStyle) {
      Object.assign(this[ids].copyContainer.style, copyStyle);
    }
    if (changed.lineHeight || (changed.minimumRows && lineHeight != null)) {
      const minHeight = minimumRows * lineHeight;
      this[ids].copyContainer.style.minHeight = `${minHeight}px`;
    }
    if (changed.value) {
       (this[
        ids
      ].inner).value = value;
      this[ids].textCopy.textContent = value;
    }
  }
  get [template]() {
    return html`
      <style>
        :host {
          display: block;
        }

        #autoSizeContainer {
          position: relative;
        }

        #inner,
        #copyContainer {
          font: inherit;
          margin: 0;
        }

        #inner {
          box-sizing: border-box;
          height: 100%;
          overflow: hidden;
          position: absolute;
          resize: none;
          top: 0;
          width: 100%;
        }

        #copyContainer {
          box-sizing: content-box;
          visibility: hidden;
          white-space: pre-wrap;
          word-wrap: break-word;
        }

        #extraSpace {
          display: inline-block;
          width: 0;
        }
      </style>
      <div id="autoSizeContainer">
        <textarea id="inner" part="inner"></textarea>
        <div id="copyContainer"><span id="textCopy"></span><span id="extraSpace">&nbsp;</span></div>
      </div>
      <div hidden>
        <slot></slot>
      </div>
    `;
  }
  get value() {
    return this[state].value;
  }
  set value(value) {
    this[setState]({
      value,
      valueTracksContent: false
    });
  }
}
function getTextFromContent( contentNodes) {
  if (contentNodes === null) {
    return "";
  }
  const texts = [...contentNodes].map(node => node.textContent);
  const text = texts.join("").trim();
  return unescapeHtml(text);
}
function unescapeHtml( html) {
  return html
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

function AriaRoleMixin(Base) {
  class AriaRole extends Base {
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.role) {
        const { role } = this[state];
        this.setAttribute("role", role);
      }
    }
    get role() {
      return super.role;
    }
    set role(role) {
      super.role = role;
      if (!this[rendering]) {
        this[setState]({ role });
      }
    }
  }
  return AriaRole;
}

const focusTest = document.createElement("div");
focusTest.attachShadow({ mode: "open", delegatesFocus: true });
const shadowRoot = focusTest.shadowRoot;
const nativeDelegatesFocus = shadowRoot.delegatesFocus;
function ComposedFocusMixin(Base) {
  class ComposedFocus extends Base {
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      this.addEventListener("mousedown", event => {
        if (!this[state].composeFocus) {
          return;
        }
        if (event.button !== 0) {
          return;
        }
        if (event.target instanceof Element) {
          const target = closestFocusableNode(event.target);
          if (target) {
            target.focus();
            event.preventDefault();
          }
        }
      });
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        composeFocus: !nativeDelegatesFocus
      });
    }
  }
  return ComposedFocus;
}

let keyboardActive = false;
const focusVisibleChangedListenerKey = Symbol("focusVisibleChangedListener");
function FocusVisibleMixin(Base) {
  return class FocusVisible extends Base {
    constructor() {
      super();
      this.addEventListener("focusout", event => {
        Promise.resolve().then(() => {
           const cast = event;
          const newFocusedElement =
            cast.relatedTarget || document.activeElement;
          const isFocusedElement = this === newFocusedElement;
          const containsFocus = deepContains(this, newFocusedElement);
          const lostFocus = !isFocusedElement && !containsFocus;
          if (lostFocus) {
            this[setState]({
              focusVisible: false
            });
            document.removeEventListener(
              "focus-visible-changed",
              this[focusVisibleChangedListenerKey]
            );
            this[focusVisibleChangedListenerKey] = null;
          }
        });
      });
      this.addEventListener("focusin", () => {
        Promise.resolve().then(() => {
          if (this[state].focusVisible !== keyboardActive) {
            this[setState]({
              focusVisible: keyboardActive
            });
          }
          if (!this[focusVisibleChangedListenerKey]) {
            this[focusVisibleChangedListenerKey] = () => refreshFocus(this);
            document.addEventListener(
              "focus-visible-changed",
              this[focusVisibleChangedListenerKey]
            );
          }
        });
      });
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        focusVisible: false
      });
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.focusVisible) {
        this.style.outline = this[state].focusVisible ? "" : "none";
      }
    }
    suppressFocusVisibility() {
      keyboardActive = false;
      refreshFocus(this);
    }
  };
}
function refreshFocus( element) {
  element[setState]({
    focusVisible: keyboardActive
  });
}
function updateKeyboardActive( newKeyboardActive) {
  if (keyboardActive !== newKeyboardActive) {
    keyboardActive = newKeyboardActive;
    const event = new CustomEvent("focus-visible-changed", {
      detail: {
        focusVisible: keyboardActive
      }
    });
    document.dispatchEvent(event);
  }
}
window.addEventListener(
  "keydown",
  () => {
    updateKeyboardActive(true);
  },
  { capture: true }
);
window.addEventListener(
  "mousedown",
  () => {
    updateKeyboardActive(false);
  },
  { capture: true }
);

function KeyboardMixin(Base) {
  class Keyboard extends Base {
    constructor() {
      super();
      this.addEventListener("keydown", async event => {
        this[raiseChangeEvents] = true;
        if (!this[state].focusVisible) {
          this[setState]({
            focusVisible: true
          });
        }
        const handled = this[keydown](event);
        if (handled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        await Promise.resolve();
        this[raiseChangeEvents] = false;
      });
    }
    get [defaultState]() {
      const tabIndex = this[delegatesFocus] ? null : 0;
      const state = Object.assign(super[defaultState], {
        tabIndex
      });
      return state;
    }
    [keydown]( event) {
      if (super[keydown]) {
        return super[keydown](event);
      }
      return false;
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.tabIndex) {
        this.tabIndex = this[state].tabIndex;
      }
    }
    get tabIndex() {
      return super.tabIndex;
    }
    set tabIndex(tabIndex) {
      let parsed = tabIndex !== null ? Number(tabIndex) : null;
      if (parsed !== null && isNaN(parsed)) {
        const defaultTabIndex$1 = this[defaultTabIndex];
        parsed = defaultTabIndex$1 ? defaultTabIndex$1 : 0;
      }
      if (parsed !== null && super.tabIndex !== parsed) {
        super.tabIndex = parsed;
      }
      if (!this[rendering]) {
        this[setState]({
          tabIndex: parsed
        });
      }
    }
  }
  return Keyboard;
}

const Base$2 = AriaRoleMixin(
  ComposedFocusMixin(
    FocusVisibleMixin(KeyboardMixin(WrappedStandardElement.wrap("button")))
  )
);
const firefox = "InstallTrigger" in window;
const mapKeysToClick = !firefox;
class Button extends Base$2 {
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      role: "button",
      treatEnterAsClick: true,
      treatSpaceAsClick: true
    });
  }
  [keydown]( event) {
    let handled;
    if (mapKeysToClick) {
      switch (event.key) {
        case " ":
          if (this[state].treatSpaceAsClick) {
            this[tap]();
            handled = true;
          }
          break;
        case "Enter":
          if (this[state].treatEnterAsClick) {
            this[tap]();
            handled = true;
          }
          break;
      }
    }
    return (
      handled || (super[keydown] && super[keydown](event))
    );
  }
  [render]( changed) {
    super[render](changed);
    if (changed.focusVisible) {
      this.style.outline = "none";
      const { focusVisible } = this[state];
      this[ids].inner.style.outline = focusVisible ? "" : "none";
    }
  }
  [tap]() {
    const clickEvent = new MouseEvent("click");
    this.dispatchEvent(clickEvent);
  }
  get [template]() {
    return concat(
      super[template],
      html`
        <style>
          :host {
            display: inline-flex;
            outline: none;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
          }
          
          #inner {
            align-items: center; /* Edge */
            color: inherit;
            display: inline-flex;
            flex: 1;
            font: inherit;
            height: 100%;
            justify-content: center;
            padding: 0;
            position: relative;
            text-align: initial; /* Edge */
            width: 100%;
          }
        </style>
      `
    );
  }
}

function DirectionSelectionMixin(Base) {
  class DirectionSelection extends Base {
    get [defaultState]() {
      const state = Object.assign(super[defaultState], {
        canGoDown: null,
        canGoLeft: null,
        canGoRight: null,
        canGoUp: null
      });
      state.onChange(
        [
          "canSelectNext",
          "canSelectPrevious",
          "languageDirection",
          "orientation",
          "rightToLeft"
        ],
        state => {
          const {
            canSelectNext,
            canSelectPrevious,
            orientation,
            rightToLeft
          } = state;
          const canGoNext = canSelectNext;
          const canGoPrevious = canSelectPrevious;
          const horizontal =
            orientation === "horizontal" || orientation === "both";
          const vertical = orientation === "vertical" || orientation === "both";
          const canGoDown = vertical && canSelectNext;
          const canGoLeft = !horizontal
            ? false
            : rightToLeft
            ? canSelectNext
            : canSelectPrevious;
          const canGoRight = !horizontal
            ? false
            : rightToLeft
            ? canSelectPrevious
            : canSelectNext;
          const canGoUp = vertical && canSelectPrevious;
          return {
            canGoDown,
            canGoLeft,
            canGoNext,
            canGoPrevious,
            canGoRight,
            canGoUp
          };
        }
      );
      return state;
    }
    [goDown]() {
      if (super[goDown]) {
        super[goDown]();
      }
      if (!this.selectNext) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectNext" method.`
        );
        return false;
      } else {
        return this.selectNext();
      }
    }
    [goEnd]() {
      if (super[goEnd]) {
        super[goEnd]();
      }
      if (!this.selectLast) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectLast" method.`
        );
        return false;
      } else {
        return this.selectLast();
      }
    }
    [goLeft]() {
      if (super[goLeft]) {
        super[goLeft]();
      }
      if (!this.selectPrevious) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectPrevious" method.`
        );
        return false;
      } else {
        return this[state] && this[state].rightToLeft
          ? this.selectNext()
          : this.selectPrevious();
      }
    }
    [goNext]() {
      if (super[goNext]) {
        super[goNext]();
      }
      return this.selectNext();
    }
    [goPrevious]() {
      if (super[goPrevious]) {
        super[goPrevious]();
      }
      return this.selectPrevious();
    }
    [goRight]() {
      if (super[goRight]) {
        super[goRight]();
      }
      if (!this.selectNext) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectNext" method.`
        );
        return false;
      } else {
        return this[state] && this[state].rightToLeft
          ? this.selectPrevious()
          : this.selectNext();
      }
    }
    [goStart]() {
      if (super[goStart]) {
        super[goStart]();
      }
      if (!this.selectFirst) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectFirst" method.`
        );
        return false;
      } else {
        return this.selectFirst();
      }
    }
    [goUp]() {
      if (super[goUp]) {
        super[goUp]();
      }
      if (!this.selectPrevious) {
        console.warn(
          `DirectionSelectionMixin expects ${this.constructor.name} to define a "selectPrevious" method.`
        );
        return false;
      } else {
        return this.selectPrevious();
      }
    }
  }
  return DirectionSelection;
}

const Base$3 = FormElementMixin(WrappedStandardElement.wrap("input"));
class Input extends Base$3 {
  [componentDidMount]() {
    super[componentDidMount]();
    this[ids].inner.addEventListener("input", () => {
      this[raiseChangeEvents] = true;
      this.value =  (this.inner).value;
      this[raiseChangeEvents] = false;
    });
    this.setAttribute("role", "none");
  }
  get [template]() {
    return concat(
      super[template],
      html`
        <style>
          #inner {
            font: inherit;
          }
        </style>
      `
    );
  }
  get value() {
    return super.value;
  }
  set value(value) {
    super.value = value;
    if (this.shadowRoot) {
       const inner = this.inner;
      this.setInnerProperty("selectionStart", inner.selectionStart);
      this.setInnerProperty("selectionEnd", inner.selectionEnd);
    }
  }
}

function KeyboardDirectionMixin(Base) {
  class KeyboardDirection extends Base {
    [goDown]() {
      if (super[goDown]) {
        return super[goDown]();
      }
    }
    [goEnd]() {
      if (super[goEnd]) {
        return super[goEnd]();
      }
    }
    [goLeft]() {
      if (super[goLeft]) {
        return super[goLeft]();
      }
    }
    [goRight]() {
      if (super[goRight]) {
        return super[goRight]();
      }
    }
    [goStart]() {
      if (super[goStart]) {
        return super[goStart]();
      }
    }
    [goUp]() {
      if (super[goUp]) {
        return super[goUp]();
      }
    }
    [keydown]( event) {
      let handled = false;
      const orientation = this[state].orientation || "both";
      const horizontal = orientation === "horizontal" || orientation === "both";
      const vertical = orientation === "vertical" || orientation === "both";
      switch (event.key) {
        case "ArrowDown":
          if (vertical) {
            handled = event.altKey
              ? this[goEnd]()
              : this[goDown]();
          }
          break;
        case "ArrowLeft":
          if (horizontal && !event.metaKey && !event.altKey) {
            handled = this[goLeft]();
          }
          break;
        case "ArrowRight":
          if (horizontal && !event.metaKey && !event.altKey) {
            handled = this[goRight]();
          }
          break;
        case "ArrowUp":
          if (vertical) {
            handled = event.altKey
              ? this[goStart]()
              : this[goUp]();
          }
          break;
        case "End":
          handled = this[goEnd]();
          break;
        case "Home":
          handled = this[goStart]();
          break;
      }
      return (
        handled ||
        (super[keydown] && super[keydown](event)) ||
        false
      );
    }
  }
  return KeyboardDirection;
}

const defaultAriaRole = {
  a: "link",
  article: "region",
  button: "button",
  h1: "sectionhead",
  h2: "sectionhead",
  h3: "sectionhead",
  h4: "sectionhead",
  h5: "sectionhead",
  h6: "sectionhead",
  hr: "sectionhead",
  iframe: "region",
  link: "link",
  menu: "menu",
  ol: "list",
  option: "option",
  output: "liveregion",
  progress: "progressbar",
  select: "select",
  table: "table",
  td: "td",
  textarea: "textbox",
  th: "th",
  ul: "list"
};

function AriaMenuMixin(Base) {
  class AriaMenu extends Base {
    get [defaultState]() {
      const base = super[defaultState];
      return Object.assign(base, {
        itemRole: base.itemRole || "menuitem",
        role: base.role || "menu"
      });
    }
    get itemRole() {
      return this[state].itemRole;
    }
    set itemRole(itemRole) {
      this[setState]({ itemRole });
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      const { selectedIndex, itemRole } = this[state];
       const items = this[state].items;
      if ((changed.items || changed.itemRole) && items) {
        items.forEach(item => {
          if (itemRole === defaultAriaRole[item.localName]) {
            item.removeAttribute("role");
          } else {
            item.setAttribute("role", itemRole);
          }
        });
      }
      if ((changed.items || changed.selectedIndex) && items) {
        items.forEach((item, index) => {
          const selected = index === selectedIndex;
          item.setAttribute("aria-checked", selected.toString());
        });
      }
      if (changed.role) {
        const { role } = this[state];
        this.setAttribute("role", role);
      }
    }
    get role() {
      return super.role;
    }
    set role(role) {
      super.role = role;
      if (!this[rendering]) {
        this[setState]({ role });
      }
    }
  }
  return AriaMenu;
}

function GenericMixin(
   Base
) {
  return class Generic extends Base {
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        generic: true
      });
    }
    get generic() {
      return this[state].generic;
    }
    set generic(generic) {
      const parsed = typeof generic === "string" ? true : Boolean(generic);
      this[setState]({
        generic: parsed
      });
    }
    [render]( changed) {
      super[render](changed);
      if (changed.generic) {
        const { generic } = this[state];
        this.toggleAttribute("generic", generic);
      }
    }
  };
}

function ItemsTextMixin(Base) {
  class ItemsText extends Base {
    get [defaultState]() {
      const state = Object.assign(super[defaultState], {
        texts: null
      });
      state.onChange("items", state => {
        const { items } = state;
        const texts = getTextsFromItems(items, this[getItemText]);
        if (texts) {
          Object.freeze(texts);
          return { texts };
        }
        return null;
      });
      return state;
    }
    [getItemText](item) {
      return getItemText$1(item);
    }
  }
  return ItemsText;
}
function getItemText$1(item) {
  return item.getAttribute("alt") || item.textContent || "";
}
function getTextsFromItems(items, getText = getItemText$1) {
  return items ? Array.from(items, item => getText(item)) : null;
}

function defaultScrollTarget(element) {
  const root = element.shadowRoot;
  const slot = root && root.querySelector("slot:not([name])");
  const scrollingParent =
    slot &&
    slot.parentNode instanceof Element &&
    getScrollableElement(slot.parentNode);
  return scrollingParent || element;
}
function isElementScrollable(element) {
  const style = getComputedStyle(element);
  const overflowX = style.overflowX;
  const overflowY = style.overflowY;
  return (
    overflowX === "scroll" ||
    overflowX === "auto" ||
    overflowY === "scroll" ||
    overflowY === "auto"
  );
}
function getScrollableElement(node) {
  for (const ancestor of selfAndComposedAncestors(node)) {
    if (ancestor instanceof HTMLElement && isElementScrollable(ancestor)) {
      return ancestor;
    }
  }
  return null;
}

function KeyboardPagedSelectionMixin(Base) {
  class KeyboardPagedSelection extends Base {
    [keydown]( event) {
      let handled = false;
      const orientation = this.orientation;
      if (orientation !== "horizontal") {
        switch (event.key) {
          case "PageDown":
            handled = this.pageDown();
            break;
          case "PageUp":
            handled = this.pageUp();
            break;
        }
      }
      return (
        handled || (super[keydown] && super[keydown](event))
      );
    }
    get orientation() {
      return (
        super.orientation ||
        (this[state] && this[state].orientation) ||
        "both"
      );
    }
    pageDown() {
      if (super.pageDown) {
        super.pageDown();
      }
      return scrollOnePage(this, true);
    }
    pageUp() {
      if (super.pageUp) {
        super.pageUp();
      }
      return scrollOnePage(this, false);
    }
    get [scrollTarget]() {
      const element = this;
      return super[scrollTarget] || defaultScrollTarget(element);
    }
  }
  return KeyboardPagedSelection;
}
function getIndexOfItemAtY(items, y, downward) {
  const start = downward ? 0 : items.length - 1;
  const end = downward ? items.length : 0;
  const step = downward ? 1 : -1;
  let index;
   let item = null;
  let itemRect;
  for (index = start; index !== end; index += step) {
    itemRect = items[index].getBoundingClientRect();
    if (itemRect.top <= y && y <= itemRect.bottom) {
      item = items[index];
      break;
    }
  }
  if (!item || !itemRect) {
    return null;
  }
  const itemStyle = getComputedStyle(item);
  const itemPaddingTop = itemStyle.paddingTop
    ? parseFloat(itemStyle.paddingTop)
    : 0;
  const itemPaddingBottom = itemStyle.paddingBottom
    ? parseFloat(itemStyle.paddingBottom)
    : 0;
  const contentTop = itemRect.top + itemPaddingTop;
  const contentBottom =
    contentTop + item.clientHeight - itemPaddingTop - itemPaddingBottom;
  if ((downward && contentTop <= y) || (!downward && contentBottom >= y)) {
    return index;
  } else {
    return index - step;
  }
}
function scrollOnePage(element, downward) {
  const scrollTarget$1 = element[scrollTarget];
  const items = element[state].items;
  const selectedIndex = element[state].selectedIndex;
  const targetRect = scrollTarget$1.getBoundingClientRect();
  const edge = downward ? targetRect.bottom : targetRect.top;
  const indexOfItemAtEdge = getIndexOfItemAtY(items, edge, downward);
  let newIndex;
  if (indexOfItemAtEdge && selectedIndex === indexOfItemAtEdge) {
    const selectedItem = items[selectedIndex];
    const selectedRect = selectedItem.getBoundingClientRect();
    const pageHeight = scrollTarget$1.clientHeight;
    const y = downward
      ? selectedRect.bottom + pageHeight
      : selectedRect.top - pageHeight;
    newIndex = getIndexOfItemAtY(items, y, downward);
  } else {
    newIndex = indexOfItemAtEdge;
  }
  if (!newIndex) {
    newIndex = downward ? items.length - 1 : 0;
  }
  const saveRaiseChangesEvents = element[raiseChangeEvents];
  element[raiseChangeEvents] = true;
  element[setState]({
    selectedIndex: newIndex
  });
  element[raiseChangeEvents] = saveRaiseChangesEvents;
  const changed = element[state].selectedIndex !== selectedIndex;
  return changed;
}

const TYPING_TIMEOUT_DURATION = 1000;

const typedPrefixKey = Symbol("typedPrefix");
const prefixTimeoutKey = Symbol("prefixTimeout");
function KeyboardPrefixSelectionMixin(Base) {
  class KeyboardPrefixSelection extends Base {
    constructor() {
      super();
      resetTypedPrefix(this);
    }
    [keydown]( event) {
      let handled;
      switch (event.key) {
        case "Backspace":
          handleBackspace(this);
          handled = true;
          break;
        case "Escape":
          resetTypedPrefix(this);
          break;
        default:
          if (
            !event.ctrlKey &&
            !event.metaKey &&
            !event.altKey &&
            event.key.length === 1
          ) {
            handlePlainCharacter(this, event.key);
          }
      }
      return (
        handled || (super[keydown] && super[keydown](event))
      );
    }
    selectItemWithTextPrefix(prefix) {
      if (super.selectItemWithTextPrefix) {
        super.selectItemWithTextPrefix(prefix);
      }
      if (prefix == null || prefix.length === 0) {
        return false;
      }
      const searchText = prefix.toLowerCase();
       const texts = this[state].texts;
      const selectedIndex = texts.findIndex(
        text => text.substr(0, prefix.length).toLowerCase() === searchText
      );
      if (selectedIndex >= 0) {
        const previousIndex = this.selectedIndex;
        this[setState]({ selectedIndex });
        return this.selectedIndex !== previousIndex;
      } else {
        return false;
      }
    }
  }
  return KeyboardPrefixSelection;
}
function handleBackspace(element) {
   const cast = element;
  const length = cast[typedPrefixKey] ? cast[typedPrefixKey].length : 0;
  if (length > 0) {
    cast[typedPrefixKey] = cast[typedPrefixKey].substr(0, length - 1);
  }
  element.selectItemWithTextPrefix(cast[typedPrefixKey]);
  setPrefixTimeout(element);
}
function handlePlainCharacter(element, char) {
   const cast = element;
  const prefix = cast[typedPrefixKey] || "";
  cast[typedPrefixKey] = prefix + char;
  element.selectItemWithTextPrefix(cast[typedPrefixKey]);
  setPrefixTimeout(element);
}
function resetPrefixTimeout(element) {
   const cast = element;
  if (cast[prefixTimeoutKey]) {
    clearTimeout(cast[prefixTimeoutKey]);
    cast[prefixTimeoutKey] = false;
  }
}
function resetTypedPrefix(element) {
   (element)[typedPrefixKey] = "";
  resetPrefixTimeout(element);
}
function setPrefixTimeout(element) {
  resetPrefixTimeout(element);
   (element)[prefixTimeoutKey] = setTimeout(() => {
    resetTypedPrefix(element);
  }, TYPING_TIMEOUT_DURATION);
}

function LanguageDirectionMixin(Base) {
  return class LanguageDirection extends Base {
    connectedCallback() {
       const element = this;
      const languageDirection = getComputedStyle(element).direction;
      const rightToLeft = languageDirection === "rtl";
      this[setState]({ rightToLeft });
      if (super.connectedCallback) {
        super.connectedCallback();
      }
    }
  };
}

function SelectedItemTextValueMixin(Base) {
  class SelectedItemTextValue extends Base {
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      const { items, pendingValue } = this[state];
      if (pendingValue && items) {
        const index = indexOfItemWithText(items, pendingValue);
        this[setState]({
          selectedIndex: index,
          pendingValue: null
        });
      }
    }
    get value() {
      return this.selectedItem == null || this.selectedItem.textContent == null
        ? ""
        : this.selectedItem.textContent;
    }
    set value(text) {
      const items = this[state].items;
      if (items === null) {
        this[setState]({
          pendingValue: text
        });
      } else {
        const selectedIndex = indexOfItemWithText(items, text);
        this[setState]({ selectedIndex });
      }
    }
  }
  return SelectedItemTextValue;
}
function indexOfItemWithText(items, text) {
  return items.findIndex(item => item.textContent === text);
}

function SelectionInViewMixin(Base) {
  class SelectionInView extends Base {
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      this.scrollSelectionIntoView();
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.selectedIndex) {
        this.scrollSelectionIntoView();
      }
    }
    scrollSelectionIntoView() {
      if (super.scrollSelectionIntoView) {
        super.scrollSelectionIntoView();
      }
      const scrollTarget$1 = this[scrollTarget];
      const { selectedIndex, items } = this[state];
      if (selectedIndex < 0 || !items) {
        return;
      }
      const selectedItem = items[selectedIndex];
      if (!selectedItem) {
        return;
      }
      const scrollTargetRect = scrollTarget$1.getBoundingClientRect();
      const itemRect = selectedItem.getBoundingClientRect();
      const bottomDelta = itemRect.bottom - scrollTargetRect.bottom;
      const leftDelta = itemRect.left - scrollTargetRect.left;
      const rightDelta = itemRect.right - scrollTargetRect.right;
      const topDelta = itemRect.top - scrollTargetRect.top;
      const orientation = this[state].orientation || "both";
      if (orientation === "horizontal" || orientation === "both") {
        if (rightDelta > 0) {
          scrollTarget$1.scrollLeft += rightDelta;
        } else if (leftDelta < 0) {
          scrollTarget$1.scrollLeft += Math.ceil(leftDelta);
        }
      }
      if (orientation === "vertical" || orientation === "both") {
        if (bottomDelta > 0) {
          scrollTarget$1.scrollTop += bottomDelta;
        } else if (topDelta < 0) {
          scrollTarget$1.scrollTop += Math.ceil(topDelta);
        }
      }
    }
    get [scrollTarget]() {
      const base = super[scrollTarget];
      const element = this;
      return base || defaultScrollTarget(element);
    }
  }
  return SelectionInView;
}

function SingleSelectionMixin(Base) {
  class SingleSelection extends Base {
    get canSelectNext() {
      return this[state].canSelectNext;
    }
    get canSelectPrevious() {
      return this[state].canSelectPrevious;
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.selectedIndex && this[raiseChangeEvents]) {
        const selectedIndex = this[state].selectedIndex;
        const event = new CustomEvent("selected-index-changed", {
          detail: { selectedIndex }
        });
        this.dispatchEvent(event);
      }
    }
    get [defaultState]() {
      const state = Object.assign(super[defaultState], {
        canSelectNext: null,
        canSelectPrevious: null,
        selectedIndex: -1,
        selectionRequired: false,
        selectionWraps: false,
        trackSelectedItem: true
      });
      state.onChange(
        ["items", "selectedIndex", "selectionRequired"],
        (state, changed) => {
          const {
            items,
            selectedIndex,
            selectionRequired,
            selectionWraps
          } = state;
          let adjustedIndex = selectedIndex;
          if (
            changed.items &&
            items &&
            !changed.selectedIndex &&
            state.trackSelectedItem
          ) {
            const selectedItem = this.selectedItem;
            if (items[selectedIndex] !== selectedItem) {
              const currentIndex = items.indexOf(selectedItem);
              if (currentIndex >= 0) {
                adjustedIndex = currentIndex;
              }
            }
          }
          if (items) {
            const validatedIndex = validateIndex(
              adjustedIndex,
              items.length,
              selectionRequired,
              selectionWraps
            );
            return {
              selectedIndex: validatedIndex
            };
          }
          return null;
        }
      );
      state.onChange(["items", "selectedIndex", "selectionWraps"], state => {
        const { items, selectedIndex, selectionWraps } = state;
        if (items) {
          const count = items.length;
          const canSelectNext =
            count === 0
              ? false
              : selectionWraps ||
                selectedIndex < 0 ||
                selectedIndex < count - 1;
          const canSelectPrevious =
            count === 0
              ? false
              : this.selectionWraps || selectedIndex < 0 || selectedIndex > 0;
          return {
            canSelectNext,
            canSelectPrevious
          };
        }
        return null;
      });
      return state;
    }
    selectFirst() {
      if (super.selectFirst) {
        super.selectFirst();
      }
      return updateSelectedIndex(this, 0);
    }
    get selectedIndex() {
      const { items, selectedIndex } = this[state];
      return items && items.length > 0 ? selectedIndex : -1;
    }
    set selectedIndex(selectedIndex) {
      const parsed = Number(selectedIndex);
      if (!isNaN(parsed)) {
        this[setState]({
          selectedIndex: parsed
        });
      }
    }
    get selectedItem() {
      const { items, selectedIndex } = this[state];
      return items && items[selectedIndex];
    }
    set selectedItem(selectedItem) {
      const { items } = this[state];
      if (!items) {
        return;
      }
      const selectedIndex = items.indexOf(selectedItem);
      if (selectedIndex >= 0) {
        this[setState]({ selectedIndex });
      }
    }
    get selectionRequired() {
      return this[state].selectionRequired;
    }
    set selectionRequired(selectionRequired) {
      this[setState]({
        selectionRequired: String(selectionRequired) === "true"
      });
    }
    get selectionWraps() {
      return this[state].selectionWraps;
    }
    set selectionWraps(selectionWraps) {
      this[setState]({
        selectionWraps: String(selectionWraps) === "true"
      });
    }
    selectLast() {
      if (super.selectLast) {
        super.selectLast();
      }
      return updateSelectedIndex(this, this[state].items.length - 1);
    }
    selectNext() {
      if (super.selectNext) {
        super.selectNext();
      }
      return updateSelectedIndex(this, this[state].selectedIndex + 1);
    }
    selectPrevious() {
      if (super.selectPrevious) {
        super.selectPrevious();
      }
      let newIndex;
      const { items, selectedIndex, selectionWraps } = this[state];
      if (
        (items && selectedIndex < 0) ||
        (selectionWraps && selectedIndex === 0)
      ) {
        newIndex = items.length - 1;
      } else if (selectedIndex > 0) {
        newIndex = selectedIndex - 1;
      } else {
        return false;
      }
      return updateSelectedIndex(this, newIndex);
    }
  }
  return SingleSelection;
}
function validateIndex(index, count, selectionRequired, selectionWraps) {
  let validatedIndex;
  if (index === -1 && selectionRequired && count > 0) {
    validatedIndex = 0;
  } else if (selectionWraps && count > 0) {
    validatedIndex = ((index % count) + count) % count;
  } else {
    validatedIndex = Math.max(Math.min(index, count - 1), -1);
  }
  return validatedIndex;
}
function updateSelectedIndex(element, selectedIndex) {
  const validatedIndex = validateIndex(
    selectedIndex,
    element[state].items.length,
    element[state].selectionRequired,
    element[state].selectionWraps
  );
  const changed = element[state].selectedIndex !== validatedIndex;
  if (changed) {
    element[setState]({
      selectedIndex: validatedIndex
    });
  }
  return changed;
}

const auxiliarycustomTags = [
  "applet",
  "basefont",
  "embed",
  "font",
  "frame",
  "frameset",
  "isindex",
  "keygen",
  "link",
  "multicol",
  "nextid",
  "noscript",
  "object",
  "param",
  "script",
  "style",
  "template",
  "noembed"
];
function isSubstantiveElement(node) {
  return (
    node instanceof Element &&
    (!node.localName || auxiliarycustomTags.indexOf(node.localName) < 0)
  );
}

function ContentItemsMixin(Base) {
  return class ContentItems extends Base {
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.items && this[raiseChangeEvents]) {
        const event = new CustomEvent("items-changed");
        this.dispatchEvent(event);
      }
    }
    get [defaultState]() {
      const state = Object.assign(super[defaultState], {
        items: null
      });
      state.onChange(["content", "items"], (state, changed) => {
         const content = state.content;
        const needsItems = content && !state.items;
        if (changed.content || needsItems) {
          const items = content
            ? Array.prototype.filter.call(content, ( item) =>
                item instanceof HTMLElement || item instanceof SVGElement
                  ? this[itemMatchesState](item, state)
                  : false
              )
            : null;
          if (items) {
            Object.freeze(items);
          }
          return { items };
        }
        return null;
      });
      return state;
    }
    [itemMatchesState](item, state) {
      const base = super[itemMatchesState]
        ? super[itemMatchesState](item, state)
        : true;
      return base && isSubstantiveElement(item);
    }
    get items() {
      return this[state] ? this[state].items : null;
    }
  };
}

function SlotItemsMixin(Base) {
  return ContentItemsMixin(SlotContentMixin(Base));
}

function TapSelectionMixin(Base) {
  return class TapSelection extends Base {
    constructor() {
      super();
      this.addEventListener("mousedown", event => {
        if (event.button !== 0) {
          return;
        }
        this[raiseChangeEvents] = true;
        this[tap](event);
        this[raiseChangeEvents] = false;
      });
    }
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      Object.assign(this.style, {
        touchAction: "manipulation",
        mozUserSelect: "none",
        msUserSelect: "none",
        webkitUserSelect: "none",
        userSelect: "none"
      });
    }
    [tap]( event) {
      const target = event.composedPath
        ? event.composedPath()[0]
        : event.target;
      const { items, selectedIndex, selectionRequired } = this[state];
      if (items && target instanceof Node) {
        const targetIndex = indexOfItemContainingTarget(items, target);
        if (
          targetIndex >= 0 ||
          (!selectionRequired && selectedIndex !== targetIndex)
        ) {
          this[setState]({
            selectedIndex: targetIndex
          });
          event.stopPropagation();
        }
      }
    }
  };
}

const Base$4 = AriaMenuMixin(
  DelegateFocusMixin(
    DirectionSelectionMixin(
      FocusVisibleMixin(
        GenericMixin(
          ItemsTextMixin(
            KeyboardDirectionMixin(
              KeyboardMixin(
                KeyboardPagedSelectionMixin(
                  KeyboardPrefixSelectionMixin(
                    LanguageDirectionMixin(
                      SelectedItemTextValueMixin(
                        SelectionInViewMixin(
                          SingleSelectionMixin(
                            SlotItemsMixin(TapSelectionMixin(ReactiveElement))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
class Menu extends Base$4 {
  [componentDidMount]() {
    super[componentDidMount]();
    this.addEventListener("mousemove", () => {
      this.suppressFocusVisibility();
    });
    if ("PointerEvent" in window) {
      this.addEventListener("pointerdown", event => this[tap](event));
    } else {
      this.addEventListener("touchstart", event => this[tap](event));
    }
    this.removeAttribute("tabindex");
  }
  [componentDidUpdate]( changed) {
    super[componentDidUpdate](changed);
    if (changed.selectedIndex && !this[state].selectionFocused) {
      const focusElement =
        this.selectedItem instanceof HTMLElement ? this.selectedItem : this;
      focusElement.focus();
      this[setState]({
        selectionFocused: true
      });
    }
  }
  get [defaultState]() {
    const state = Object.assign(super[defaultState], {
      highlightSelection: true,
      orientation: "vertical",
      selectionFocused: false
    });
    state.onChange("selectedIndex", () => ({
      selectionFocused: false
    }));
    return state;
  }
  async highlightSelectedItem() {
    const keyboardActive = this[state].focusVisible;
    const probablyDesktop = matchMedia("(pointer: fine)").matches;
    if (keyboardActive || probablyDesktop) {
      const flashDuration = 75;
      this[setState]({ highlightSelection: false });
      await new Promise(resolve => setTimeout(resolve, flashDuration));
      this[setState]({ highlightSelection: true });
      await new Promise(resolve => setTimeout(resolve, flashDuration));
    }
  }
  [itemMatchesState](item, state) {
    const base = super[itemMatchesState]
      ? super[itemMatchesState](item, state)
      : true;
     const cast = item;
    return base && !cast.disabled;
  }
  [render]( changed) {
    super[render](changed);
    const { selectedIndex, items } = this[state];
    if ((changed.items || changed.selectedIndex) && items) {
      items.forEach((item, index) => {
        item.toggleAttribute("selected", index === selectedIndex);
      });
    }
    if (
      (changed.items ||
        changed.selectedIndex ||
        changed.selectionFocused ||
        changed.focusVisible) &&
      items
    ) {
      items.forEach((item, index) => {
        const selected = index === selectedIndex;
        const isDefaultFocusableItem = selectedIndex < 0 && index === 0;
        if (!this[state].selectionFocused) {
          if (selected || isDefaultFocusableItem) {
            item.tabIndex = 0;
          }
        } else {
          if (!(selected || isDefaultFocusableItem)) {
            item.removeAttribute("tabindex");
          }
        }
        const suppressFocus =
          (selected && !this[state].focusVisible) ||
          isDefaultFocusableItem;
        item.style.outline = suppressFocus ? "none" : "";
      });
    }
  }
  get [scrollTarget]() {
    return this[ids].content;
  }
  get [template]() {
    return html`
      <style>
        :host {
          box-sizing: border-box;
          cursor: default;
          display: flex;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }

        #content {
          display: flex;
          flex: 1;
          flex-direction: column;
          max-height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch; /* for momentum scrolling */
        }
        
        ::slotted(*) {
          flex-shrink: 0;
          touch-action: manipulation;
        }

        :host([generic]) ::slotted(*) {
          padding: 0.25em;
        }
        :host([generic]) ::slotted([selected]) {
          background: highlight;
          color: highlighttext;
        }

        @media (pointer: coarse) {
          ::slotted(*) {
            padding: 1em;
          }
        }

        ::slotted(option) {
          font: inherit;
          min-height: inherit;
        }
      </style>
      <div id="content" role="none">
        <slot></slot>
      </div>
    `;
  }
}

const Base$5 = AriaRoleMixin(ReactiveElement);
class Backdrop extends Base$5 {
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      role: "none"
    });
  }
  get [template]() {
    return html`
      <style>
        :host {
          height: 100%;
          left: 0;
          position: fixed;
          top: 0;
          touch-action: manipulation;
          width: 100%;
        }
      </style>
      <slot></slot>
    `;
  }
}

function DisabledMixin(Base) {
  class Disabled extends Base {
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      reflectDisabledAttribute(this);
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.disabled) {
        reflectDisabledAttribute(this);
      }
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        disabled: false
      });
    }
    get disabled() {
      return this[state].disabled;
    }
    set disabled(disabled) {
      const parsed =
        typeof disabled === "boolean" ? disabled : disabled !== null;
      this[setState]({
        disabled: parsed
      });
    }
  }
  return Disabled;
}
function reflectDisabledAttribute( element) {
  element.toggleAttribute("disabled", element.disabled);
}

const closePromiseKey = Symbol("closePromise");
const closeResolveKey = Symbol("closeResolve");
function OpenCloseMixin(Base) {
  class OpenClose extends Base {
    async close(closeResult) {
      if (super.close) {
        await super.close();
      }
      this[setState]({ closeResult });
      await this.toggle(false);
    }
    get closed() {
      return this[state] && !this[state].opened;
    }
    set closed(closed) {
      const parsed = String(closed) === "true";
      this.toggle(!parsed);
    }
    get closeFinished() {
      return this[state].openCloseEffects
        ? this[state].effect === "close" &&
            this[state].effectPhase === "after"
        : this.closed;
    }
    get closeResult() {
      return this[state].closeResult;
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.opened && this[raiseChangeEvents]) {
        const openedChangedEvent = new CustomEvent("opened-changed", {
          detail: {
            closeResult: this[state].closeResult,
            opened: this[state].opened
          }
        });
        this.dispatchEvent(openedChangedEvent);
        if (this[state].opened) {
          const openedEvent = new CustomEvent("opened");
          this.dispatchEvent(openedEvent);
        } else {
          const closedEvent = new CustomEvent("closed", {
            detail: {
              closeResult: this[state].closeResult
            }
          });
          this.dispatchEvent(closedEvent);
        }
      }
      const closeResolve = this[closeResolveKey];
      if (this.closeFinished && closeResolve) {
        this[closeResolveKey] = null;
        this[closePromiseKey] = null;
        closeResolve(this[state].closeResult);
      }
    }
    get [defaultState]() {
      const defaults = {
        closeResult: null,
        opened: false
      };
      if (this[startEffect]) {
        Object.assign(defaults, {
          effect: "close",
          effectPhase: "after",
          openCloseEffects: true
        });
      }
      return Object.assign(super[defaultState], defaults);
    }
    async open() {
      if (super.open) {
        await super.open();
      }
      this[setState]({ closeResult: undefined });
      await this.toggle(true);
    }
    get opened() {
      return this[state] && this[state].opened;
    }
    set opened(opened) {
      const parsed = String(opened) === "true";
      this[setState]({ closeResult: undefined });
      this.toggle(parsed);
    }
    async toggle(opened = !this.opened) {
      if (super.toggle) {
        await super.toggle(opened);
      }
      const changed = opened !== this[state].opened;
      if (changed) {
         const changes = { opened };
        if (this[state].openCloseEffects) {
          changes.effect = opened ? "open" : "close";
          if (this[state].effectPhase === "after") {
            changes.effectPhase = "before";
          }
        }
        await this[setState](changes);
      }
    }
    whenClosed() {
      if (!this[closePromiseKey]) {
        this[closePromiseKey] = new Promise(resolve => {
          this[closeResolveKey] = resolve;
        });
      }
      return this[closePromiseKey];
    }
  }
  return OpenClose;
}

class OverlayFrame extends ReactiveElement {
  get [template]() {
    return html`
      <style>
        :host {
          background: white;
          border: 1px solid rgba(0, 0, 0, 0.2);
          box-shadow: 0 0px 10px rgba(0, 0, 0, 0.5);
          position: relative;
        }
      </style>
      <slot></slot>
    `;
  }
}

const appendedToDocumentKey = Symbol("appendedToDocument");
const defaultZIndexKey = Symbol("assignedZIndex");
const restoreFocusToElementKey = Symbol("restoreFocusToElement");
function OverlayMixin(Base) {
  class Overlay extends Base {
    constructor() {
      super();
      this.addEventListener("blur", event => {
        const newFocusedElement = event.relatedTarget || document.activeElement;
        const node = this;
        if (newFocusedElement instanceof HTMLElement) {
          const focusInside = deepContains(node, newFocusedElement);
          if (!focusInside) {
            if (this.opened) {
              this[restoreFocusToElementKey] = newFocusedElement;
            } else {
              newFocusedElement.focus();
              this[restoreFocusToElementKey] = null;
            }
          }
        }
      });
    }
    get autoFocus() {
      return this[state].autoFocus;
    }
    set autoFocus(autoFocus) {
      this[setState]({ autoFocus });
    }
    [componentDidMount]() {
      if (super[componentDidMount]) {
        super[componentDidMount]();
      }
      openedChanged(this);
      if (this[state].persistent && !hasZIndex(this)) {
        bringToFront(this);
      }
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.opened) {
        openedChanged(this);
      }
      if (
        !this[state].persistent &&
        this.closeFinished &&
        this[appendedToDocumentKey]
      ) {
        this[appendedToDocumentKey] = false;
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      }
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        autoFocus: true,
        persistent: false
      });
    }
    async open() {
      if (!this[state].persistent && !this.isConnected) {
        this[appendedToDocumentKey] = true;
        document.body.appendChild(this);
      }
      if (super.open) {
        await super.open();
      }
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.effectPhase || changed.opened || changed.persistent) {
        if (!this[state].persistent) {
          const closed =
            typeof this.closeFinished === "undefined"
              ? this.closed
              : this.closeFinished;
          this.style.display = closed ? "none" : "";
          if (closed) {
            if (this[defaultZIndexKey]) {
              this.style.zIndex = "";
              this[defaultZIndexKey] = null;
            }
          } else if (this[defaultZIndexKey]) {
            this.style.zIndex = this[defaultZIndexKey];
          } else {
            if (!hasZIndex(this)) {
              bringToFront(this);
            }
          }
        }
      }
    }
  }
  return Overlay;
}
function bringToFront(element) {
  const defaultZIndex = maxZIndexInUse() + 1;
  element[defaultZIndexKey] = defaultZIndex;
  element.style.zIndex = defaultZIndex.toString();
}
function hasZIndex(element) {
  const computedZIndex = getComputedStyle(element).zIndex;
  const explicitZIndex = element.style.zIndex;
  const isExplicitZIndexNumeric = !isNaN(parseInt(explicitZIndex));
  if (computedZIndex === "auto") {
    return isExplicitZIndexNumeric;
  }
  if (computedZIndex === "0" && !isExplicitZIndexNumeric) {
    const parent =
      element.assignedSlot ||
      (element instanceof ShadowRoot ? element.host : element.parentNode);
    if (!(parent instanceof HTMLElement)) {
      return true;
    }
    if (!hasZIndex(parent)) {
      return false;
    }
  }
  return true;
}
function maxZIndexInUse() {
  const elements = document.body.querySelectorAll("*");
  const zIndices = Array.from(elements, element => {
    const style = getComputedStyle(element);
    let zIndex = 0;
    if (style.position !== "static" && style.zIndex !== "auto") {
      const parsed = style.zIndex ? parseInt(style.zIndex) : 0;
      zIndex = !isNaN(parsed) ? parsed : 0;
    }
    return zIndex;
  });
  return Math.max(...zIndices);
}
function openedChanged( element) {
  if (element[state].autoFocus) {
    if (element[state].opened) {
      if (
        !element[restoreFocusToElementKey] &&
        document.activeElement !== document.body
      ) {
        element[restoreFocusToElementKey] = document.activeElement;
      }
      const focusElement = firstFocusableElement(element);
      if (focusElement) {
        focusElement.focus();
      }
    } else {
      if (element[restoreFocusToElementKey]) {
        element[restoreFocusToElementKey].focus();
        element[restoreFocusToElementKey] = null;
      }
    }
  }
}

const Base$6 = OpenCloseMixin(OverlayMixin(SlotContentMixin(ReactiveElement)));
class Overlay extends Base$6 {
  get backdrop() {
    return this[ids] && this[ids].backdrop;
  }
  get backdropPartType() {
    return this[state].backdropPartType;
  }
  set backdropPartType(backdropPartType) {
    this[setState]({ backdropPartType });
  }
  [componentDidUpdate]( changed) {
    super[componentDidUpdate](changed);
    if (changed.opened && this[state].content) {
      this[state].content.forEach(element => {
        if (element[checkSize]) {
          element[checkSize]();
        }
      });
    }
  }
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      backdropPartType: Backdrop,
      framePartType: OverlayFrame
    });
  }
  get frame() {
    return this[ids].frame;
  }
  get framePartType() {
    return this[state].framePartType;
  }
  set framePartType(framePartType) {
    this[setState]({ framePartType });
  }
  [render]( changed) {
    super[render](changed);
    if (changed.backdropPartType) {
      transmute(
        this[ids].backdrop,
        this[state].backdropPartType
      );
    }
    if (changed.framePartType) {
      transmute(
        this[ids].frame,
        this[state].framePartType
      );
    }
  }
  get [template]() {
    return html`
      <style>
        :host {
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-height: 100vh;
          max-width: 100vw;
          outline: none;
          position: fixed;
          -webkit-tap-highlight-color: transparent;
        }

        #frame {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          max-height: 100%;
          max-width: 100%;
          overscroll-behavior: contain;
          pointer-events: initial;
          position: relative;
        }

        #frameContent {
          display: flex;
          flex: 1;
          flex-direction: column;
          height: 100%;
          overflow: hidden;
          width: 100%;
        }
      </style>
      <div id="backdrop" part="backdrop" tabindex="-1"></div>
      <div id="frame" part="frame" role="none">
        <div id="frameContent">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

const implicitCloseListenerKey = Symbol("implicitCloseListener");
function PopupModalityMixin(Base) {
  class PopupModality extends Base {
    constructor() {
      super();
      this.addEventListener("blur", blurHandler.bind(this));
    }
    [componentDidUpdate]( changed) {
      if (super[componentDidUpdate]) {
        super[componentDidUpdate](changed);
      }
      if (changed.opened) {
        if (this.opened) {
          const callback =
            "requestIdleCallback" in window
              ? window["requestIdleCallback"]
              : setTimeout;
          callback(() => {
            if (this.opened) {
              addEventListeners(this);
            }
          });
        } else {
          removeEventListeners(this);
        }
      }
    }
    get closeOnWindowResize() {
      return this[state].closeOnWindowResize;
    }
    set closeOnWindowResize(closeOnWindowResize) {
      this[setState]({ closeOnWindowResize });
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        closeOnWindowResize: true,
        role: "alert"
      });
    }
    [keydown]( event) {
      let handled = false;
      switch (event.key) {
        case "Escape":
          this.close({
            canceled: "Escape"
          });
          handled = true;
          break;
      }
      return handled || (super.keydown && super.keydown(event)) || false;
    }
    [render]( changed) {
      if (super[render]) {
        super[render](changed);
      }
      if (changed.role) {
        const { role } = this[state];
        this.setAttribute("role", role);
      }
    }
    get role() {
      return super.role;
    }
    set role(role) {
      super.role = role;
      if (!this[rendering]) {
        this[setState]({ role });
      }
    }
  }
  return PopupModality;
}
function addEventListeners( element) {
  element[implicitCloseListenerKey] = closeHandler.bind(element);
  window.addEventListener("blur", element[implicitCloseListenerKey]);
  window.addEventListener("resize", element[implicitCloseListenerKey]);
  window.addEventListener("scroll", element[implicitCloseListenerKey]);
}
function removeEventListeners( element) {
  if (element[implicitCloseListenerKey]) {
    window.removeEventListener("blur", element[implicitCloseListenerKey]);
    window.removeEventListener("resize", element[implicitCloseListenerKey]);
    window.removeEventListener("scroll", element[implicitCloseListenerKey]);
    element[implicitCloseListenerKey] = null;
  }
}
async function blurHandler( event) {
   const element = this;
  const newFocusedElement =
     (event).relatedTarget || document.activeElement;
  if (
    newFocusedElement instanceof Element &&
    !deepContains(element, newFocusedElement)
  ) {
    element[raiseChangeEvents] = true;
    await element.close();
    element[raiseChangeEvents] = false;
  }
}
async function closeHandler( event) {
   const element = this;
  const handleEvent =
    event.type !== "resize" || element[state].closeOnWindowResize;
  if (!ownEvent(element, event) && handleEvent) {
    element[raiseChangeEvents] = true;
    await element.close();
    element[raiseChangeEvents] = false;
  }
}

const Base$7 = KeyboardMixin(PopupModalityMixin(Overlay));
class Popup extends Base$7 {
  [render]( changed) {
    super[render](changed);
    if (changed.backdropPartType) {
      this[ids].backdrop.addEventListener(
        "mousedown",
        mousedownHandler.bind(this)
      );
      if (!("PointerEvent" in window)) {
        this[ids].backdrop.addEventListener(
          "touchend",
          mousedownHandler
        );
      }
    }
  }
}
async function mousedownHandler(event) {
  const element = this;
  element[raiseChangeEvents] = true;
  await element.close();
  element[raiseChangeEvents] = false;
  event.preventDefault();
  event.stopPropagation();
}

const resizeListenerKey = Symbol("resizeListener");
const Base$8 = AriaRoleMixin(
  DisabledMixin(
    FocusVisibleMixin(LanguageDirectionMixin(OpenCloseMixin(ReactiveElement)))
  )
);
class PopupSource extends Base$8 {
  get backdropPartType() {
    return this[state].backdropPartType;
  }
  set backdropPartType(backdropPartType) {
    this[setState]({ backdropPartType });
  }
  [componentDidMount]() {
    super[componentDidMount]();
    if (this[state].opened) {
      waitThenRenderOpened(this);
    }
    this.setAttribute("aria-haspopup", "true");
  }
  [componentDidUpdate]( changed) {
    super[componentDidUpdate](changed);
    if (changed.opened) {
      if (this.opened) {
        waitThenRenderOpened(this);
      } else {
        removeEventListeners$1(this);
      }
    } else if (this.opened && !this[state].popupMeasured) {
      measurePopup(this);
    }
  }
  get [defaultState]() {
    const result = Object.assign(super[defaultState], {
      backdropPartType: Backdrop,
      framePartType: OverlayFrame,
      horizontalAlign: "start",
      popupHeight: null,
      popupMeasured: false,
      popupPosition: "below",
      popupPartType: Popup,
      popupWidth: null,
      role: "none",
      roomAbove: null,
      roomBelow: null,
      roomLeft: null,
      roomRight: null,
      sourcePartType: "div"
    });
    result.onChange(["opened"], state => {
      if (!state.opened) {
        return {
          popupHeight: null,
          popupMeasured: false,
          popupWidth: null,
          roomAbove: null,
          roomBelow: null,
          roomLeft: null,
          roomRight: null
        };
      }
      return null;
    });
    return result;
  }
  get frame() {
    return  (this[ids].popup).frame;
  }
  get framePartType() {
    return this[state].framePartType;
  }
  set framePartType(framePartType) {
    this[setState]({ framePartType });
  }
  get horizontalAlign() {
    return this[state].horizontalAlign;
  }
  set horizontalAlign(horizontalAlign) {
    this[setState]({ horizontalAlign });
  }
  [render]( changed) {
    super[render](changed);
    if (changed.framePartType) {
      if ("framePartType" in this[ids].popup) {
        const { framePartType } = this[state];
         (this[
          ids
        ].popup).framePartType = framePartType;
      }
    }
    if (changed.popupPartType) {
      transmute(
        this[ids].popup,
        this[state].popupPartType
      );
      this[ids].popup.addEventListener("opened", () => {
        if (!this.opened) {
          this[raiseChangeEvents] = true;
          this.open();
          this[raiseChangeEvents] = false;
        }
      });
      this[ids].popup.addEventListener("closed", event => {
        if (!this.closed) {
          this[raiseChangeEvents] = true;
          const cast = event;
          const closeResult = cast.detail.closeResult;
          this.close(closeResult);
          this[raiseChangeEvents] = false;
        }
      });
    }
    if (changed.backdropPartType) {
      if ("backdropPartType" in this[ids].popup) {
        const { backdropPartType } = this[state];
         (this[
          ids
        ].popup).backdropPartType = backdropPartType;
      }
    }
    if (
      changed.horizontalAlign ||
      changed.popupMeasured ||
      changed.rightToLeft
    ) {
      const {
        horizontalAlign,
        popupHeight,
        popupMeasured,
        popupPosition,
        popupWidth,
        rightToLeft,
        roomAbove,
        roomBelow,
        roomLeft,
        roomRight
      } = this[state];
      const fitsAbove = popupHeight <= roomAbove;
      const fitsBelow = popupHeight <= roomBelow;
      const canLeftAlign = popupWidth <= roomRight;
      const canRightAlign = popupWidth <= roomLeft;
      const preferPositionBelow = popupPosition === "below";
      const positionBelow =
        (preferPositionBelow && (fitsBelow || roomBelow >= roomAbove)) ||
        (!preferPositionBelow && !fitsAbove && roomBelow >= roomAbove);
      const fitsVertically =
        (positionBelow && fitsBelow) || (!positionBelow && fitsAbove);
      const maxFrameHeight = fitsVertically
        ? null
        : positionBelow
        ? roomBelow
        : roomAbove;
      const bottom = positionBelow ? null : 0;
      let left;
      let right;
      let maxFrameWidth;
      if (horizontalAlign === "stretch") {
        left = 0;
        right = 0;
        maxFrameWidth = null;
      } else {
        const preferLeftAlign =
          horizontalAlign === "left" ||
          (rightToLeft
            ? horizontalAlign === "end"
            : horizontalAlign === "start");
        const alignLeft =
          (preferLeftAlign && (canLeftAlign || roomRight >= roomLeft)) ||
          (!preferLeftAlign && !canRightAlign && roomRight >= roomLeft);
        left = alignLeft ? 0 : null;
        right = !alignLeft ? 0 : null;
        const fitsHorizontally =
          (alignLeft && roomRight) || (!alignLeft && roomLeft);
        maxFrameWidth = fitsHorizontally
          ? null
          : alignLeft
          ? roomRight
          : roomLeft;
      }
      const opacity = popupMeasured ? null : 0;
      const position = popupMeasured ? "absolute" : "fixed";
      const popup = this[ids].popup;
      Object.assign(popup.style, {
        bottom,
        left,
        opacity,
        position,
        right
      });
      const frame =  (popup).frame;
      Object.assign(frame.style, {
        maxHeight: maxFrameHeight ? `${maxFrameHeight}px` : null,
        maxWidth: maxFrameWidth ? `${maxFrameWidth}px` : null
      });
      this[ids].popupContainer.style.top = positionBelow ? null : "0";
    }
    if (changed.sourcePartType) {
      transmute(
        this[ids].source,
        this[state].sourcePartType
      );
    }
    if (changed.opened) {
      const { opened } = this[state];
       (this[ids].popup).opened = opened;
      this.setAttribute("aria-expanded", opened.toString());
    }
    if (changed.disabled) {
      if ("disabled" in this[ids].source) {
        const { disabled } = this[state];
         (this[ids].source).disabled = disabled;
      }
    }
  }
  get popupPosition() {
    return this[state].popupPosition;
  }
  set popupPosition(popupPosition) {
    this[setState]({ popupPosition });
  }
  get popupPartType() {
    return this[state].popupPartType;
  }
  set popupPartType(popupPartType) {
    this[setState]({ popupPartType });
  }
  get sourcePartType() {
    return this[state].sourcePartType;
  }
  set sourcePartType(sourcePartType) {
    this[setState]({ sourcePartType });
  }
  get [template]() {
    return html`
      <style>
        :host {
          display: inline-block;
          position: relative;
        }

        #source {
          height: 100%;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
          width: 100%;
        }

        #popupContainer {
          height: 0;
          outline: none;
          position: absolute;
          width: 100%;
        }

        #popup {
          align-items: initial;
          height: initial;
          justify-content: initial;
          left: initial;
          outline: none;
          position: absolute;
          top: initial;
          width: initial;
        }
      </style>
      <div id="source" part="source">
        <slot name="source"></slot>
      </div>
      <div id="popupContainer" role="none">
        <div id="popup" part="popup" exportparts="backdrop, frame" role="none">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
function addEventListeners$1( element) {
   const cast = element;
  cast[resizeListenerKey] = () => {
    measurePopup(element);
  };
  window.addEventListener("resize", cast[resizeListenerKey]);
}
function removeEventListeners$1( element) {
   const cast = element;
  if (cast[resizeListenerKey]) {
    window.removeEventListener("resize", cast[resizeListenerKey]);
    cast[resizeListenerKey] = null;
  }
}
function measurePopup(element) {
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  const popupRect = element[ids].popup.getBoundingClientRect();
  const sourceRect = element.getBoundingClientRect();
  element[setState]({
    popupHeight: popupRect.height,
    popupMeasured: true,
    popupWidth: popupRect.width,
    roomAbove: sourceRect.top,
    roomBelow: Math.ceil(windowHeight - sourceRect.bottom),
    roomLeft: sourceRect.right,
    roomRight: Math.ceil(windowWidth - sourceRect.left),
    windowHeight,
    windowWidth
  });
}
function waitThenRenderOpened(element) {
  setTimeout(() => {
    if (element.opened) {
      measurePopup(element);
      addEventListeners$1(element);
    }
  });
}

const Base$9 = GenericMixin(KeyboardMixin(PopupSource));
class PopupButton extends Base$9 {
  [componentDidMount]() {
    super[componentDidMount]();
    this.addEventListener("focus", async event => {
      const hostFocused = !ownEvent(this[ids].popup, event);
      const measured = this[state].popupHeight !== null;
      if (hostFocused && this.opened && measured) {
        this[raiseChangeEvents] = true;
        await this.close();
        this[raiseChangeEvents] = false;
      }
    });
  }
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      role: "button",
      sourcePartType: "button"
    });
  }
  [keydown]( event) {
    let handled;
    switch (event.key) {
      case " ":
      case "ArrowDown":
      case "ArrowUp":
        if (this.closed) {
          this.open();
          handled = true;
        }
        break;
    }
    return (
      handled || (super[keydown] && super[keydown](event))
    );
  }
  [render]( changed) {
    super[render](changed);
    if (changed.sourcePartType) {
      const source = this[ids].source;
      source.addEventListener("mousedown", event => {
        if (this.disabled) {
          return;
        }
        const cast = event;
        if (cast.button && cast.button !== 0) {
          return;
        }
        setTimeout(() => {
          if (!this.opened) {
            this[raiseChangeEvents] = true;
            this.open();
            this[raiseChangeEvents] = false;
          }
        });
        event.stopPropagation();
      });
      source.tabIndex = -1;
    }
  }
  get [template]() {
    return concat(
      super[template],
      html`
        <style>
          #source {
            cursor: default;
            display: block;
            outline: none;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
            -moz-user-select: none;
            -ms-user-select: none;
            -webkit-user-select: none;
            user-select: none;
            white-space: nowrap;
          }

          button#source {
            font: inherit;
          }

          :host([generic]) #source {
            background: buttonface;
            color: inherit;
            font: inherit;
            margin: 0;
            padding: 0.25em 0.5em;
          }
        </style>
      `
    );
  }
}

const documentMouseupListenerKey = Symbol("documentMouseupListener");
class MenuButton extends PopupButton {
  [componentDidMount]() {
    super[componentDidMount]();
    this.addEventListener("mousemove", event => {
      const target = event.target;
      if (target && target instanceof Node) {
        const hoverIndex = indexOfItemContainingTarget(this.items, target);
        if (hoverIndex !== this[state].menuSelectedIndex) {
          this[raiseChangeEvents] = true;
          this[setState]({
            menuSelectedIndex: hoverIndex
          });
          this[raiseChangeEvents] = false;
        }
      }
    });
     const cast = this;
    cast[documentMouseupListenerKey] = handleMouseup.bind(this);
    if (this[state].opened) {
      addDocumentListeners(this);
    }
  }
  [componentDidUpdate]( changed) {
    super[componentDidUpdate](changed);
    if (changed.menuSelectedIndex) {
      const selectedItem =
        this[state].menuSelectedIndex >= 0
          ? this.items[this[state].menuSelectedIndex]
          : null;
      this.itemSelected(selectedItem);
    }
    if (changed.opened) {
      if (this[state].opened) {
        addDocumentListeners(this);
      } else {
        removeDocumentListeners(this);
      }
    }
  }
  get defaultMenuSelectedIndex() {
    return -1;
  }
  get [defaultState]() {
    const state = Object.assign(super[defaultState], {
      dragSelect: true,
      menuPartType: Menu,
      menuSelectedIndex: -1,
      selectedItem: null,
      touchstartX: null,
      touchstartY: null
    });
    state.onChange("opened", state => {
      if (state.opened) {
        return {
          dragSelect: true,
          menuSelectedIndex: this.defaultMenuSelectedIndex,
          selectedItem: null,
          touchStartX: null,
          touchStartY: null
        };
      } else {
        return {
          menuSelectedIndex: -1
        };
      }
    });
    return state;
  }
  disconnectedCallback() {
    if (super.disconnectedCallback) {
      super.disconnectedCallback();
    }
     const cast = this;
    document.removeEventListener("mouseup", cast[documentMouseupListenerKey]);
    cast[documentMouseupListenerKey] = null;
  }
  async highlightSelectedItemAndClose() {
    const raiseChangeEvents$1 = this[raiseChangeEvents];
    const selectionDefined = this[state].menuSelectedIndex >= 0;
    const closeResult = selectionDefined
      ? this.items[this[state].menuSelectedIndex]
      : undefined;
     const menu = this[ids].menu;
    if (selectionDefined && "highlightSelectedItem" in menu) {
      await menu.highlightSelectedItem();
    }
    const saveRaiseChangeEvents = this[raiseChangeEvents];
    this[raiseChangeEvents] = raiseChangeEvents$1;
    await this.close(closeResult);
    this[raiseChangeEvents] = saveRaiseChangeEvents;
  }
  get items() {
    const menu = this[ids] && this[ids].menu;
    return menu ? menu.items : null;
  }
  itemSelected(item) {
    if (this[raiseChangeEvents]) {
      const event = new CustomEvent("menu-item-selected", {
        detail: {
          selectedItem: item
        }
      });
      this.dispatchEvent(event);
    }
  }
  [keydown]( event) {
    switch (event.key) {
      case "Enter":
        if (this.opened) {
          this.highlightSelectedItemAndClose();
          return true;
        }
    }
    const base = super[keydown] && super[keydown](event);
    if (base) {
      return true;
    }
    if (this.opened && !event.metaKey && !event.altKey) {
      switch (event.key) {
        case "ArrowDown":
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "End":
        case "Home":
        case "PageDown":
        case "PageUp":
        case " ":
          return true;
      }
    }
    return false;
  }
  get menuPartType() {
    return this[state].menuPartType;
  }
  set menuPartType(menuPartType) {
    this[setState]({ menuPartType });
  }
  [render]( changed) {
    super[render](changed);
    if (changed.popupPartType) {
      this[ids].popup.tabIndex = -1;
    }
    if (changed.menuPartType) {
      transmute(
        this[ids].menu,
        this[state].menuPartType
      );
      this[ids].menu.addEventListener("blur", async event => {
        const cast = event;
        const newFocusedElement = cast.relatedTarget || document.activeElement;
        if (
          this.opened &&
          !deepContains(this[ids].menu, newFocusedElement)
        ) {
          this[raiseChangeEvents] = true;
          await this.close();
          this[raiseChangeEvents] = false;
        }
      });
      this[ids].menu.addEventListener("mousedown", event => {
        if (this.opened) {
          event.stopPropagation();
          event.preventDefault();
        }
      });
      this[ids].menu.addEventListener("mouseup", async event => {
        const menuSelectedIndex = this[state].menuSelectedIndex;
        if (this[state].dragSelect || menuSelectedIndex >= 0) {
          event.stopPropagation();
          this[raiseChangeEvents] = true;
          await this.highlightSelectedItemAndClose();
          this[raiseChangeEvents] = false;
        } else {
          event.stopPropagation();
        }
      });
      this[ids].menu.addEventListener(
        "selected-index-changed",
        event => {
          this[raiseChangeEvents] = true;
          const cast = event;
          this[setState]({
            menuSelectedIndex: cast.detail.selectedIndex
          });
          this[raiseChangeEvents] = false;
        }
      );
    }
    if (changed.menuSelectedIndex) {
      const menu =  (this[ids].menu);
      if ("selectedIndex" in menu) {
        menu.selectedIndex = this[state].menuSelectedIndex;
      }
    }
  }
  get [template]() {
    const base = super[template];
    const menuTemplate = html`
      <div id="menu" part="menu">
        <slot></slot>
      </div>
    `;
    const defaultSlot = base.content.querySelector("slot:not([name])");
    if (defaultSlot) {
      transmute(defaultSlot, menuTemplate);
    }
    const sourceTemplate = html`
      <slot>
        <svg id="toggleIcon" part="toggle-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </slot>
    `;
    const sourceSlot = base.content.querySelector('slot[name="source"]');
    if (sourceSlot) {
      transmute(sourceSlot, sourceTemplate);
    }
    return concat(
      base,
      html`
        <style>
          #menu {
            background: window;
            border: none;
            max-height: 100%;
            padding: 0.5em 0;
          }

          #source {
            align-items: center;
            display: flex;
          }

          #toggleIcon {
            display: block;
            fill: currentColor;
          }
        </style>
      `
    );
  }
}
function addDocumentListeners( element) {
   const cast = element;
  document.addEventListener("mouseup", cast[documentMouseupListenerKey]);
}
async function handleMouseup( event) {
  const element = this;
  const hitTargets = element.shadowRoot.elementsFromPoint(
    event.clientX,
    event.clientY
  );
  const overSource = hitTargets.indexOf(element[ids].source) >= 0;
  if (element.opened) {
    if (overSource) {
      if (element[state].dragSelect) {
        element[raiseChangeEvents] = true;
        element[setState]({
          dragSelect: false
        });
        element[raiseChangeEvents] = false;
      }
    } else {
      element[raiseChangeEvents] = true;
      await element.close();
      element[raiseChangeEvents] = false;
    }
  }
}
function removeDocumentListeners( element) {
   const cast = element;
  document.removeEventListener("mouseup", cast[documentMouseupListenerKey]);
}

const Base$a = GenericMixin(ReactiveElement);
class MenuItem extends Base$a {
  [componentDidUpdate]( changed) {
    if (changed.selected ) {
      const event = new CustomEvent("selected-changed", {
        detail: {
          selected: this[state].selected
        }
      });
      this.dispatchEvent(event);
    }
  }
  get [defaultState]() {
    return Object.assign(super[defaultState], {
      selected: false
    });
  }
  get selected() {
    return this[state].selected;
  }
  set selected(selected) {
    this[setState]({ selected });
  }
  get [template]() {
    return html`
      <style>
        :host([generic]) {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          font-size: 10pt;
          padding-left: 2em !important;
          padding-right: 2em !important;
          white-space: nowrap;
        }
      </style>
      <div id="container">
        <slot></slot>
      </div>
    `;
  }
}

function HoverMixin(Base) {
  return class Hover extends Base {
    constructor() {
      super();
      this.addEventListener("mouseenter", async event => {
        this[raiseChangeEvents] = true;
        this[mouseenter](event);
        await Promise.resolve();
        this[raiseChangeEvents] = false;
      });
      this.addEventListener("mouseleave", async event => {
        this[raiseChangeEvents] = true;
        this[mouseleave](event);
        await Promise.resolve();
        this[raiseChangeEvents] = false;
      });
    }
    get [defaultState]() {
      return Object.assign(super[defaultState], {
        hover: false
      });
    }
    [mouseenter]( event) {
      if (super[mouseenter]) {
        super[mouseenter](event);
      }
      this[setState]({
        hover: true
      });
    }
    [mouseleave]( event) {
      if (super[mouseleave]) {
        super[mouseleave](event);
      }
      this[setState]({
        hover: false
      });
    }
  };
}

export { AttributeMarshallingMixin, AutoSizeTextarea, Button, DelegateFocusMixin, DirectionSelectionMixin, FocusVisibleMixin, FormElementMixin, HoverMixin, Input, KeyboardDirectionMixin, KeyboardMixin, MenuButton, MenuItem, Popup, ReactiveElement, WrappedStandardElement, internal, template$1 as template, utilities };
//# sourceMappingURL=elix.js.map
